/*! iS3 Teamwear · Tri suit builder
 *  A live tri-suit design tool for ideas: set a colour, gradient or pattern for every panel (Pantone-based),
 *  place logos and text, then send the design to Chris by WhatsApp or email. Nothing is bought here.
 *  No dependencies. Generated by tools/build.ps1 – edit the files in src/.
 *  The traced suit shapes and the Pantone chart are in is3-suit-builder-data.js, and the patterns in
 *  is3-suit-builder-patterns.js; both load first.
 */
(function () {
  'use strict';
  if (!window.IS3KB_DATA || !window.IS3KB_PATTERNS) { if (window.console) console.error('iS3 suit builder: is3-suit-builder-data.js or is3-suit-builder-patterns.js did not load'); return; }
  const { SHAPE, PANTONE_RAW } = window.IS3KB_DATA;
  const { PATTERNS, PATTERN_IDS, PAT_SIZES, patName, patSize, patternMarkup, patternThumb } = window.IS3KB_PATTERNS;
  let CONFIG = null;


/* ==========================================================================
   01 · GEOMETRY
   The suit is traced from the iS3 flat template (see 00b-suit-shapes.js):
   set-in short sleeves, an underarm strip + leaf side panel, a lower side
   panel, waist band, thigh pockets, and on the back a label panel, yoke and
   lower-back pockets. Everything is drawn in a 500 x 680 box, centre x = 250.
   Pieces stored for the viewer's right are mirrored for the left.
   ========================================================================== */

const VB = { w: 500, h: 680, cx: 250 };

/* ---- tiny path helpers (absolute M C L Z only) ---- */
const fmt = (n) => String(Math.round(n * 100) / 100);
/* mirror a path string (absolute commands, x/y pairs) about a vertical line */
function mirrorD(d, cx = VB.cx) {
  let i = 0;
  return d.replace(/-?\d*\.?\d+/g, (m) => {
    const v = parseFloat(m);
    const out = i % 2 === 0 ? 2 * cx - v : v;
    i++;
    return fmt(out);
  });
}
const bothD = (d) => d + mirrorD(d); //              the piece and its mirror image, as one path
function bbox(d) {
  const n = (d.match(/-?\d*\.?\d+/g) || []).map(Number);
  let x0 = 1e9;
  let x1 = -1e9;
  let y0 = 1e9;
  let y1 = -1e9;
  for (let i = 0; i + 1 < n.length; i += 2) {
    x0 = Math.min(x0, n[i]);
    x1 = Math.max(x1, n[i]);
    y0 = Math.min(y0, n[i + 1]);
    y1 = Math.max(y1, n[i + 1]);
  }
  return { x0, x1, y0, y1 };
}

/* ---- the two views ---- */
const SUIT_FRONT = SHAPE.front;
const SUIT_BACK = SHAPE.back;
const SUIT = { front: SUIT_FRONT, back: SUIT_BACK };

/* extents used to size gradients per colour slot: a gradient runs across the panels it colours */
const SIL_BOX = bbox(SUIT_FRONT.sil);
const WAIST_Y = Math.round(bbox(SUIT_FRONT.legs).y0);
const boxOf = (d) => { const b = bbox(d); return { x1: b.x0, y1: b.y0, x2: b.x1, y2: b.y1 }; };
const EXTENT = {
  base: { x1: SIL_BOX.x0, y1: SIL_BOX.y0, x2: SIL_BOX.x1, y2: WAIST_Y }, //  front and back panels
  acc1: boxOf(bothD(SUIT_FRONT.pink)), //                                      arm pit
  acc2: boxOf(bothD(SUIT_FRONT.sideLow)), //                                   side panels
  acc3: boxOf(bothD(SUIT_FRONT.sleeve)), //                                    sleeves
  legs: { x1: SIL_BOX.x0 + 50, y1: WAIST_Y, x2: SIL_BOX.x1 - 50, y2: SIL_BOX.y1 },
};
/* where the underarm meets the torso (right side); used for shading */
const ARMPIT = { x: 352, y: 150 };

/* ---- seam lines per view (every piece outline; silhouette is stroked separately) ---- */
function seamPaths(view) {
  const v = SUIT[view];
  const pairs = ['sleeve', 'pink', 'sideLow', 'hip', 'pocket', 'hem'];
  const back = ['yoke', 'lobe'];
  const one = view === 'front' ? ['waist', 'collar', 'collarIn'] : ['strip', 'label', 'mid', 'lower', 'collar'];
  let d = '';
  pairs.concat(view === 'back' ? back : []).forEach((k) => { d += bothD(v[k]); });
  one.forEach((k) => { d += v[k]; });
  return d;
}
const SEAMS = { front: seamPaths('front'), back: seamPaths('back') };

/* ---- flat sheet: the four groups of pieces as they are cut (sleeves, side panels) ---- */
const FLAT = (() => {
  const f = SHAPE.flat;
  const SL = 1.55; //               sleeve scale on the sheet
  const SP = 0.92; //               side panel scale on the sheet
  const sleeves = [
    { id: 'sleeveR', side: 'R', d: f.sleeve, x: 70, y: 56, s: SL, w: f.sleeveW, h: f.sleeveH, label: 'RIGHT SLEEVE', lx: 145, ly: 252 },
    { id: 'sleeveL', side: 'L', d: mirrorD(f.sleeve, f.sleeveW / 2), x: 280, y: 56, s: SL, w: f.sleeveW, h: f.sleeveH, label: 'LEFT SLEEVE', lx: 355, ly: 252 },
  ];
  const col = (side, x0) => {
    const m = side === 'L' ? (d) => mirrorD(d, f.sideW / 2) : (d) => d;
    return { side, x: x0, y: 292, s: SP, w: f.sideW, h: f.sideH, a: m(f.sideA), b: m(f.sideB), c: m(f.sideC), label: side === 'R' ? 'RIGHT SIDE PANEL' : 'LEFT SIDE PANEL', lx: x0 + (f.sideW * SP) / 2, ly: 292 + f.sideH * SP + 26 };
  };
  const sides = [col('R', 115), col('L', 325)];
  return { f, sleeves, sides, SL, SP };
})();
/* gradient extents on the flat sheet, in each piece's own units (arm pit = the two upper pieces of a side panel) */
const FLAT_EXTENT = {
  acc1: boxOf(SHAPE.flat.sideA + SHAPE.flat.sideB),
  acc2: boxOf(SHAPE.flat.sideC),
  acc3: boxOf(SHAPE.flat.sleeve),
};
/* where each flat piece group takes its pattern from: the part of the suit it belongs to, at the same size on screen
   (pattern units to a piece's own units: scale 1 / sheet scale, then centre on the garment panel) */
const FLAT_PAT = {
  acc1: 'translate(-359.6 -116.4) scale(1.087)',
  acc2: 'translate(-332.8 -17.8) scale(1.087)',
  acc3: 'translate(-207 -52.4) scale(.645)',
};

/* ==========================================================================
   02 · RENDER
   Turns the colour choices into SVG markup. A slot is a flat colour, a
   gradient or a pattern (02b-patterns.js). Each slot paints its own panels,
   and nothing else:
     base  front and back panels (with the collar, waist band and back yoke)
     acc1  arm pit
     acc2  side panels
     acc3  sleeves
     logos the iS3 triangles, and the iS3 name on the back
     legs  the whole of the shorts, top to hem
   Per view, in this order: panels, sleeves, legs, arm pit, side panels,
   brand marks, seams, soft shading. The front and back are drawn from their
   own traced pieces. The flat sheet lays the sleeves and side panels out as
   they are cut.
   ========================================================================== */

/* ---------- paints (flat colours or userSpace gradients) ---------- */
function dirCoords(dir, e) {
  const cx = (e.x1 + e.x2) / 2;
  const cy = (e.y1 + e.y2) / 2;
  switch (dir) {
    case 'h': return [e.x1, cy, e.x2, cy];
    case 'd1': return [e.x1, e.y1, e.x2, e.y2];
    case 'd2': return [e.x1, e.y2, e.x2, e.y1];
    default: return [cx, e.y1, cx, e.y2];
  }
}
/* one paint per colour slot; a gradient runs across the extent of the panels that slot colours */
function resolvePaints(slots, idp, extents = EXTENT) {
  let defs = '';
  const P = {};
  Object.keys(slots).forEach((k) => {
    const s = slots[k];
    if (s.mode === 'grad') {
      const [x1, y1, x2, y2] = dirCoords(s.dir || 'v', extents[k] || EXTENT[k]);
      const id = `${idp}g-${k}`;
      defs += `<linearGradient id="${id}" gradientUnits="userSpaceOnUse" x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}"><stop offset="0" stop-color="${s.a}"/><stop offset="1" stop-color="${s.b}"/></linearGradient>`;
      P[k] = `url(#${id})`;
    } else {
      P[k] = s.a;
    }
  });
  return { defs, P };
}

/* a piece drawn on the right of the suit, plus its mirror image on the left */
const mirrored = (markup) => `<g transform="translate(${VB.w} 0) scale(-1 1)">${markup}</g>`;
const both = (markup) => markup + mirrored(markup);

/* ---------- brand marks (the iS3 triangle, and "iS3" on the back) ---------- */
const markAt = (x, y, rot, size, fill) =>
  `<g transform="translate(${fmt(x)} ${fmt(y)}) rotate(${fmt(rot)}) scale(${fmt(size)})">` +
  `<path d="M-6 -5H6L0 5Z" fill="${fill}"/><path d="M-3.1 -2.6H3.1L0 2.7Z" fill="none" stroke="#fff" stroke-opacity=".55" stroke-width=".8"/></g>`;
function marksMarkup(view, fill) {
  const v = SUIT[view];
  let o = v.marks.map((m) => markAt(m[0], m[1], m[2], m[3], fill)).join('');
  if (view === 'back') {
    o += `<text x="${v.text[0]}" y="${fmt(v.text[1] + 5.4)}" text-anchor="middle" font-family="Archivo,Arial,sans-serif" font-weight="700" font-size="15" fill="${fill}">iS3</text>`;
  }
  return o;
}

/* a pattern slot is its first colour with the pattern drawn over its own panels (see 02b-patterns.js) */
const patternOver = (s, id, parts, tf = '') => (s.mode === 'pat'
  ? `<clipPath id="${id}">${parts.map((d) => `<path d="${d}"/>`).join('')}</clipPath><g clip-path="url(#${id})">${tf ? `<g transform="${tf}">` : ''}${patternMarkup(s, `${id}-`)}${tf ? '</g>' : ''}</g>`
  : '');

/* ---------- one garment view ---------- */
function garmentMarkup(view, st, idp) {
  const { P } = st.paints;
  const S = st.slots;
  const v = SUIT[view];
  const over = (k, parts) => patternOver(S[k], `${idp}pc-${k}`, parts);
  /* a slot with exactly the base's pattern has it already (the base pattern runs under every piece), so it draws nothing */
  const key = (s) => (s.mode === 'pat' ? `${s.pat}|${s.size}|${s.seed}|${s.a}|${s.b}` : '');
  const piece = (k, markup) => (key(S[k]) && key(S[k]) === key(S.base) ? '' : markup);
  let o = `<path d="${v.sil}" fill="${P.base}"/>${over('base', [v.sil])}`; //                       front and back panels (and whatever no other slot paints)
  o += piece('acc3', `<path d="${bothD(v.sleeve)}" fill="${P.acc3}"/>${over('acc3', [bothD(v.sleeve)])}`); //   sleeves
  /* legs: the shorts and every leg piece in one colour (the stroke closes hairline gaps to the outline) */
  o += piece('legs', `<path d="${v.legs}" fill="${P.legs}" stroke="${P.legs}" stroke-width="4" stroke-linejoin="round"/>` +
    ['hip', 'pocket', 'hem'].map((k) => `<path d="${bothD(v[k])}" fill="${P.legs}"/>`).join('') +
    over('legs', [v.legs, bothD(v.hip), bothD(v.pocket), bothD(v.hem)]));
  o += piece('acc1', `<path d="${bothD(v.pink)}" fill="${P.acc1}"/>${over('acc1', [bothD(v.pink)])}`); //          arm pit
  o += piece('acc2', `<path d="${bothD(v.sideLow)}" fill="${P.acc2}"/>${over('acc2', [bothD(v.sideLow)])}`); //   side panels
  if (view === 'front') o += `<path d="${v.collarIn}" fill="#8d8d8d" opacity=".85"/>`;
  o += marksMarkup(view, S.logos.a); //                                                              the brand marks have a colour of their own (Logos)
  return o;
}

const seamLine = (d, w = 1) =>
  `<path d="${d}" fill="none" stroke="rgba(0,0,0,.36)" stroke-width="${w}" stroke-linecap="round" stroke-linejoin="round"/>` +
  `<path d="${d}" fill="none" stroke="rgba(255,255,255,.24)" stroke-width="${w * 0.75}" stroke-linecap="round" stroke-linejoin="round" transform="translate(.7 .7)"/>`;

function detailLayer(view) {
  const v = SUIT[view];
  let o = seamLine(SEAMS[view]);
  if (view === 'front') {
    const z = `M250 ${v.zip[0]}V${v.zip[1]}`;
    o += `<path d="${z}" stroke="rgba(0,0,0,.45)" stroke-width="1.4" fill="none"/><path d="${z}" stroke="rgba(255,255,255,.35)" stroke-width="1" stroke-dasharray="1.4 1.6" fill="none"/>`;
    o += `<rect x="248.4" y="${v.zip[0] - 5}" width="3.2" height="15" rx="1.4" fill="#2a2a2a"/>`;
    o += `<circle cx="${v.pad[0]}" cy="${v.pad[1]}" r="${v.pad[2]}" fill="none" stroke="rgba(255,255,255,.35)" stroke-width="1.2" stroke-dasharray="1.6 1.6"/>`;
  } else {
    o += seamLine(`M250 ${v.seamY[0]}V${v.seamY[1]}`);
    o += `<path d="${v.pad}" fill="none" stroke="rgba(255,255,255,.35)" stroke-width="1.2" stroke-dasharray="1.6 1.6"/>`;
  }
  return o;
}

function shadeLayer(idp, view) {
  const x0 = SIL_BOX.x0;
  const x1 = SIL_BOX.x1;
  const shadow = `<circle cx="${ARMPIT.x}" cy="${ARMPIT.y}" r="30" fill="url(#${idp}shA)"/>`;
  return (
    `<linearGradient id="${idp}shH" x1="${x0}" y1="0" x2="${x1}" y2="0" gradientUnits="userSpaceOnUse">` +
    `<stop offset="0" stop-color="#000" stop-opacity=".16"/><stop offset=".13" stop-color="#000" stop-opacity="0"/>` +
    `<stop offset=".5" stop-color="#fff" stop-opacity=".07"/><stop offset=".87" stop-color="#000" stop-opacity="0"/>` +
    `<stop offset="1" stop-color="#000" stop-opacity=".16"/></linearGradient>` +
    `<radialGradient id="${idp}shA" gradientUnits="userSpaceOnUse" cx="${ARMPIT.x}" cy="${ARMPIT.y}" r="30"><stop offset="0" stop-color="#000" stop-opacity=".2"/><stop offset="1" stop-color="#000" stop-opacity="0"/></radialGradient>` +
    `<path d="${SUIT[view].sil}" fill="url(#${idp}shH)"/>` +
    both(shadow)
  );
}

/* full garment group for one view (no <svg> root) */
function suitMarkup(view, st, idp = '') {
  const sil = SUIT[view].sil;
  return (
    `<defs>${st.paints.defs}<clipPath id="${idp}sil"><path d="${sil}"/></clipPath></defs>` +
    `<g clip-path="url(#${idp}sil)">` +
    garmentMarkup(view, st, idp) +
    detailLayer(view) +
    shadeLayer(idp, view) +
    `</g>` +
    `<path d="${sil}" fill="none" stroke="rgba(0,0,0,.5)" stroke-width="1.1" stroke-linejoin="round"/>`
  );
}

/* ---------- flat sheet: the pieces as they are cut ---------- */
const FLAT_LABEL = 'text-anchor="middle" font-family="Archivo,Arial,sans-serif" font-weight="600" font-size="12" letter-spacing="1.5" fill="#8c8b87"';
const FLAT_NOTE = 'font-family="Archivo,Arial,sans-serif" font-weight="600" font-size="8.5" letter-spacing="1" fill="#8c8b87"';
/* union of every flat piece, for clipping artwork placed on the flat view */
function panelClipMarkup() {
  let s = '';
  FLAT.sleeves.forEach((p) => { s += `<path d="${p.d}" transform="translate(${p.x} ${p.y}) scale(${p.s})"/>`; });
  FLAT.sides.forEach((c) => { s += `<path d="${c.a}${c.b}${c.c}" transform="translate(${c.x} ${c.y}) scale(${c.s})"/>`; });
  return s;
}

function panelsMarkup(st, idp = 'p-') {
  /* the flat pieces are drawn in their own units, so their gradients are measured in those units too */
  const flat = resolvePaints(st.slots, `${idp}f-`, FLAT_EXTENT);
  const P = flat.P;
  const mark = st.slots.logos.a;
  let body = '';
  const edge = (d, s) => `<path d="${d}" fill="none" stroke="rgba(0,0,0,.55)" stroke-width="${fmt(1.6 / s)}" stroke-linejoin="round"/>`;

  FLAT.sleeves.forEach((p) => {
    body +=
      `<g transform="translate(${p.x} ${p.y}) scale(${p.s})">` +
      `<path d="${p.d}" fill="${P.acc3}"/>${patternOver(st.slots.acc3, `${idp}fp-${p.id}`, [p.d], FLAT_PAT.acc3)}${markAt(p.w / 2, 20, 0, 1.33, mark)}` +
      edge(p.d, p.s) +
      `</g><text x="${p.lx}" y="${p.ly}" ${FLAT_LABEL}>${p.label}</text>`;
  });

  FLAT.sides.forEach((c) => {
    const right = c.side === 'R';
    body +=
      `<g transform="translate(${c.x} ${c.y}) scale(${c.s})">` +
      `<path d="${c.a}" fill="${P.acc1}"/><path d="${c.b}" fill="${P.acc1}"/><path d="${c.c}" fill="${P.acc2}"/>` +
      patternOver(st.slots.acc1, `${idp}fp-a-${c.side}`, [c.a, c.b], FLAT_PAT.acc1) +
      patternOver(st.slots.acc2, `${idp}fp-c-${c.side}`, [c.c], FLAT_PAT.acc2) +
      edge(c.a, c.s) + edge(c.b, c.s) + edge(c.c, c.s) +
      `</g><text x="${fmt(c.lx)}" y="${fmt(c.ly)}" ${FLAT_LABEL}>${c.label}</text>`;
    /* where the armpit falls on the strip: a short leader line and a label on the outer side */
    const ay = c.y + FLAT.f.armpitY * c.s;
    const ox = right ? c.x + 12 * c.s : c.x + c.w * c.s - 12 * c.s;
    const ex = right ? c.x - 18 : c.x + c.w * c.s + 18;
    const tx = right ? ex - 4 : ex + 4;
    body +=
      `<path d="M${fmt(ox)} ${fmt(ay)}L${fmt(ex)} ${fmt(ay)}" stroke="#b9b7b2" stroke-width="1"/>` +
      `<text x="${fmt(tx)}" y="${fmt(ay - 2)}" text-anchor="${right ? 'end' : 'start'}" ${FLAT_NOTE}>ARMPIT</text>` +
      `<text x="${fmt(tx)}" y="${fmt(ay + 8.5)}" text-anchor="${right ? 'end' : 'start'}" ${FLAT_NOTE}>${right ? 'RIGHT' : 'LEFT'}</text>`;
  });
  return `<defs>${flat.defs}</defs>${body}`;
}

/* ==========================================================================
   04 · DATA
   Colours, presets, fonts and small helpers.
   ========================================================================== */

/* ---- Pantone chart → lookup tables ---- */
const PANTONE = PANTONE_RAW.split(';').map((s) => {
  const i = s.lastIndexOf('=');
  const label = s.slice(0, i);
  return { label, name: /^PMS /.test(label) ? label : `PMS ${label}`, hex: `#${s.slice(i + 1)}` };
});
const PMS_BY_LABEL = new Map(PANTONE.map((c) => [c.label, c]));

/* a colour in state is { h: '#RRGGBB', n: 'PMS 286' | 'White' | '' } */
function C(label) {
  if (label === 'White') return { h: '#FFFFFF', n: 'White' };
  const p = PMS_BY_LABEL.get(label) || PMS_BY_LABEL.get(`PMS ${label}`);
  return p ? { h: p.hex, n: p.name } : { h: '#888888', n: '' };
}
const hexToRgb = (hex) => {
  const v = hex.replace('#', '');
  return [parseInt(v.slice(0, 2), 16), parseInt(v.slice(2, 4), 16), parseInt(v.slice(4, 6), 16)];
};
const luminance = (hex) => {
  const [r, g, b] = hexToRgb(hex).map((v) => {
    const s = v / 255;
    return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};
const isDark = (hex) => luminance(hex) < 0.36;
const contrastInk = (hex) => (isDark(hex) ? '#FFFFFF' : '#141413');

/* nearest Pantone chip for any colour (weighted RGB, good enough for a hint) */
const nearCache = new Map();
function nearestPms(hex) {
  const key = hex.toUpperCase();
  if (nearCache.has(key)) return nearCache.get(key);
  const [r, g, b] = hexToRgb(key);
  let best = null;
  let bd = Infinity;
  for (let i = 0; i < PANTONE.length; i++) {
    const p = PANTONE[i];
    const [pr, pg, pb] = p._rgb || (p._rgb = hexToRgb(p.hex));
    const rm = (r + pr) / 2;
    const dr = r - pr;
    const dg = g - pg;
    const db = b - pb;
    const d = (2 + rm / 256) * dr * dr + 4 * dg * dg + (2 + (255 - rm) / 256) * db * db;
    if (d < bd) { bd = d; best = p; }
  }
  nearCache.set(key, best);
  return best;
}
const colourName = (c) => c.n || `Custom ${c.h.toUpperCase()}`;
const colourLong = (c) => (c.n ? `${c.n} (${c.h.toUpperCase()})` : `Custom ${c.h.toUpperCase()} (nearest ${nearestPms(c.h).name})`);

/* ---- quick-pick swatches, 8 × 6 ---- */
const POPULAR = [
  'White', 'Cool Gray 1', 'Cool Gray 3', 'Cool Gray 7', 'Cool Gray 11', 'PMS 433', 'Black', 'Black 6',
  'PMS 5395', 'PMS 282', 'PMS 281', 'PMS 287', 'PMS 286', 'PMS 2728', 'PMS 300', 'PMS 2925',
  'PMS 306', 'PMS 3125', 'PMS 3272', 'PMS 3242', 'PMS 3435', 'PMS 349', 'PMS 348', 'PMS 361',
  'PMS 375', 'PMS 382', 'PMS 3945', 'PMS 109', 'PMS 123', 'PMS 137', 'PMS 1495', 'PMS 165',
  'Orange 021', 'PMS 172', 'Red 032', 'PMS 186', 'PMS 187', 'PMS 202', 'PMS 219', 'PMS 232',
  'PMS 2685', 'PMS 267', 'PMS 268', 'PMS 2617', 'PMS 216', 'PMS 476', 'PMS 730', 'PMS 465',
].map(C);

/* ---- flag / national colours  [front and back panels, arm pit, side panels]; the sleeves follow the panels and the logos the arm pit ---- */
const FLAGS = [
  ['Wales', 'White', 'Red 032', 'PMS 348'],
  ['England', 'White', 'PMS 186', 'PMS 281'],
  ['Scotland', 'PMS 300', 'White', 'PMS 281'],
  ['Northern Ireland', 'PMS 348', 'White', 'Red 032'],
  ['Ireland', 'PMS 348', 'White', 'PMS 1495'],
  ['Great Britain', 'PMS 281', 'PMS 186', 'White'],
  ['USA', 'PMS 281', 'PMS 186', 'White'],
  ['Canada', 'PMS 186', 'White', 'Black'],
  ['Australia', 'PMS 348', 'PMS 116', 'White'],
  ['New Zealand', 'Black', 'White', 'Cool Gray 7'],
  ['South Africa', 'PMS 342', 'PMS 123', 'PMS 281'],
  ['France', 'PMS 286', 'White', 'PMS 186'],
  ['Germany', 'Black', 'PMS 186', 'PMS 116'],
  ['Spain', 'PMS 186', 'PMS 123', 'PMS 187'],
  ['Italy', 'PMS 300', 'White', 'PMS 348'],
  ['Netherlands', 'PMS 165', 'White', 'PMS 286'],
  ['Belgium', 'Black', 'PMS 116', 'Red 032'],
  ['Denmark', 'PMS 186', 'White', 'Cool Gray 7'],
  ['Sweden', 'PMS 300', 'PMS 116', 'PMS 281'],
  ['Norway', 'PMS 186', 'PMS 281', 'White'],
  ['Switzerland', 'PMS 186', 'White', 'Black'],
  ['Japan', 'White', 'PMS 186', 'PMS 281'],
  ['Brazil', 'PMS 355', 'PMS 109', 'PMS 286'],
].map(([name, b, a1, a2]) => ({ name, base: C(b), acc1: C(a1), acc2: C(a2), acc3: C(b), logos: C(a1) }));

/* ---- "Randomise" palettes  [front and back panels, arm pit, side panels, legs]; the sleeves follow the panels and the logos the arm pit ---- */
const PALETTES = [
  ['PMS 281', 'PMS 306', 'White', 'Black'],
  ['Black', 'PMS 375', 'White', 'Black'],
  ['PMS 186', 'White', 'Black', 'Black'],
  ['White', 'PMS 281', 'PMS 186', 'PMS 281'],
  ['PMS 286', 'PMS 109', 'White', 'PMS 282'],
  ['PMS 3435', 'PMS 375', 'White', 'Black'],
  ['PMS 165', 'Black', 'White', 'Black'],
  ['PMS 2685', 'PMS 3125', 'White', 'Black'],
  ['PMS 232', 'Black', 'White', 'Black'],
  ['Cool Gray 11', 'PMS 165', 'White', 'Cool Gray 11'],
  ['PMS 348', 'PMS 116', 'White', 'Black'],
  ['PMS 300', 'White', 'PMS 186', 'PMS 281'],
  ['PMS 187', 'PMS 123', 'White', 'PMS 433'],
  ['Black', 'PMS 2925', 'PMS 3945', 'Black'],
  ['PMS 3272', 'PMS 281', 'White', 'PMS 282'],
  ['White', 'Black', 'PMS 172', 'Black'],
  ['PMS 268', 'PMS 375', 'White', 'Black'],
  ['PMS 5395', 'PMS 306', 'PMS 232', 'PMS 5395'],
].map(([b, a1, a2, l]) => ({ base: C(b), acc1: C(a1), acc2: C(a2), acc3: C(b), legs: C(l), logos: C(a1) }));

/* the colour slots, in the order they are shown; each one colours its own panels (see 02-render.js) */
const SLOT_DEFS = [
  { key: 'base', label: 'Front and Back Panels', hint: 'The main body panels, front and back.' },
  { key: 'acc1', label: 'Arm Pit', hint: 'The panel under each arm.' },
  { key: 'acc2', label: 'Side Panels', hint: 'The long panel down each side of the body.' },
  { key: 'acc3', label: 'Sleeves', hint: 'Both sleeves.' },
  { key: 'logos', label: 'Logos', hint: 'The iS3 triangles on the front, back and sleeves, and the iS3 name on the back, in one flat colour.', flat: true },
  { key: 'legs', label: 'Legs', hint: 'The whole of the shorts, from waist to hem, in one flat colour.', flat: true },
];
const isFlatOnly = (key) => SLOT_DEFS.some((d) => d.key === key && d.flat); //  a slot with no gradient or pattern choice
const DIRS = [
  { id: 'v', label: 'Top to bottom', icon: 'M12 4v16M6 14l6 6 6-6' },
  { id: 'h', label: 'Left to right', icon: 'M4 12h16M14 6l6 6-6 6' },
  { id: 'd1', label: 'Diagonal down', icon: 'M5 5l14 14M9 19h10V9' },
  { id: 'd2', label: 'Diagonal up', icon: 'M5 19L19 5M9 5h10v10' },
];

/* ---- text fonts (Google Fonts) ---- */
const FONTS = [
  { id: 'archivo-black', name: 'Archivo Black', css: "'Archivo Black', sans-serif", gf: 'Archivo+Black' },
  { id: 'anton', name: 'Anton', css: "Anton, sans-serif", gf: 'Anton' },
  { id: 'bebas', name: 'Bebas Neue', css: "'Bebas Neue', sans-serif", gf: 'Bebas+Neue' },
  { id: 'oswald', name: 'Oswald', css: "Oswald, sans-serif", gf: 'Oswald:wght@600', weight: 600 },
  { id: 'barlow', name: 'Barlow Condensed', css: "'Barlow Condensed', sans-serif", gf: 'Barlow+Condensed:wght@700', weight: 700 },
  { id: 'russo', name: 'Russo One', css: "'Russo One', sans-serif", gf: 'Russo+One' },
  { id: 'racing', name: 'Racing Sans One', css: "'Racing Sans One', sans-serif", gf: 'Racing+Sans+One' },
  { id: 'alfa', name: 'Alfa Slab One', css: "'Alfa Slab One', serif", gf: 'Alfa+Slab+One' },
  { id: 'playfair', name: 'Playfair Display', css: "'Playfair Display', serif", gf: 'Playfair+Display:wght@800', weight: 800 },
  { id: 'bungee', name: 'Bungee', css: "Bungee, sans-serif", gf: 'Bungee' },
  { id: 'marker', name: 'Permanent Marker', css: "'Permanent Marker', cursive", gf: 'Permanent+Marker' },
  { id: 'pacifico', name: 'Pacifico', css: "Pacifico, cursive", gf: 'Pacifico' },
];
const FONT_BY_ID = new Map(FONTS.map((f) => [f.id, f]));
const GOOGLE_FONTS_URL = `https://fonts.googleapis.com/css2?${FONTS.map((f) => `family=${f.gf}`).join('&')}&display=swap`;

const VIEWS = [
  { id: 'front', label: 'Front' },
  { id: 'back', label: 'Back' },
  { id: 'panels', label: 'Sleeves + side panels' },
];
const VIEW_LABEL = { front: 'Front', back: 'Back', panels: 'Sleeves + side panels' };
const MAX_ART_PER_VIEW = 5;
const MAX_FILE_MB = 10;
const PREVIEWABLE = /^(png|jpe?g|gif|webp|svg|bmp|avif)$/i;
const ACCEPT_EXT = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg', 'pdf', 'ai', 'eps'];

/* ==========================================================================
   05 · STATE
   One mutable state object, an undo/redo stack, a local draft and a
   compact shareable encoding of the design.
   ========================================================================== */

const STORE_KEY = 'is3kb:suit:v3'; // v3: one colour per panel (arm pit, side panels, sleeves, legs), no pattern designs
const SLOT_KEYS = ['base', 'acc1', 'acc2', 'acc3', 'legs', 'logos']; // the order a design link keeps them in; the colour list on screen follows SLOT_DEFS
const LOGO_W = 100; // base width of a logo in view units (before scale)
const TEXT_SIZE = 44; // base font size of text in view units (before scale)

let state;
let activeView = 'front';
let selectedId = null;
const assets = new Map(); // id -> { id, name, ext, ar, src, previewable, file, url, status }
const undoStack = [];
const redoStack = [];
const listeners = new Set();
let lastCoalesce = { key: null, t: 0 };

const uid = () => Math.random().toString(36).slice(2, 8) + Date.now().toString(36).slice(-3);
const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
const round = (v, d = 0) => { const m = 10 ** d; return Math.round(v * m) / m; };

function defaultState() {
  return {
    v: 1,
    /* mode is 'flat', 'grad' (a to b) or 'pat' (pattern `pat` in b over a, at `size`, from `seed`) */
    slots: {
      base: { mode: 'flat', a: C('PMS 281'), b: C('PMS 306'), dir: 'v', pat: 'marble', size: 2, seed: 1 },
      acc1: { mode: 'flat', a: C('PMS 306'), b: C('PMS 281'), dir: 'v', pat: 'marble', size: 2, seed: 1 },
      acc2: { mode: 'flat', a: C('White'), b: C('PMS 306'), dir: 'v', pat: 'marble', size: 2, seed: 1 },
      acc3: { mode: 'flat', a: C('PMS 281'), b: C('PMS 306'), dir: 'v', pat: 'marble', size: 2, seed: 1 },
      legs: { mode: 'flat', a: C('Black 6'), b: C('PMS 433'), dir: 'v', pat: 'marble', size: 2, seed: 1 },
      logos: { mode: 'flat', a: C('PMS 306'), b: C('PMS 281'), dir: 'v', pat: 'marble', size: 2, seed: 1 },
    },
    items: [],
    notes: '',
    deadline: '',
    flag: '',
  };
}

/* ---------- subscribe / emit ---------- */
function on(fn) { listeners.add(fn); return () => listeners.delete(fn); }
function emit(what = 'all') { listeners.forEach((fn) => fn(what)); }

/* ---------- mutate with undo support ---------- */
function mutate(fn, what = 'all', coalesceKey = null) {
  const now = Date.now();
  const coalesced = coalesceKey && lastCoalesce.key === coalesceKey && now - lastCoalesce.t < 900;
  if (!coalesced) {
    undoStack.push(JSON.stringify(state));
    if (undoStack.length > 80) undoStack.shift();
    redoStack.length = 0;
  }
  lastCoalesce = { key: coalesceKey, t: now };
  fn(state);
  persistSoon();
  emit(what);
}
function undo() {
  if (!undoStack.length) return;
  redoStack.push(JSON.stringify(state));
  state = JSON.parse(undoStack.pop());
  lastCoalesce = { key: null, t: 0 };
  if (!state.items.some((i) => i.id === selectedId)) selectedId = null;
  persistSoon();
  emit('all');
}
function redo() {
  if (!redoStack.length) return;
  undoStack.push(JSON.stringify(state));
  state = JSON.parse(redoStack.pop());
  lastCoalesce = { key: null, t: 0 };
  if (!state.items.some((i) => i.id === selectedId)) selectedId = null;
  persistSoon();
  emit('all');
}
const canUndo = () => undoStack.length > 0;
const canRedo = () => redoStack.length > 0;

/* ---------- selection / view ---------- */
function select(id) {
  if (selectedId === id) return;
  selectedId = id;
  emit('selection');
}
function setView(v) {
  if (activeView === v) return;
  activeView = v;
  selectedId = null;
  emit('view');
}
const itemsIn = (view) => state.items.filter((i) => i.view === view);
const getItem = (id) => state.items.find((i) => i.id === id);

/* ---------- items ---------- */
function defaultPlacement(view, type) {
  const n = itemsIn(view).length;
  const nudge = (n % 3) * 14;
  if (view === 'front') return type === 'logo' ? { x: 306 - nudge, y: 128 + nudge, s: 0.7 } : { x: 250, y: 214 + nudge, s: 1 };
  if (view === 'back') return type === 'logo' ? { x: 250, y: 200 + nudge, s: 0.7 } : { x: 250, y: 262 + nudge, s: 1 };
  const right = n % 2 === 0; // flat sheet: right sleeve on the left, left sleeve on the right
  return type === 'logo' ? { x: right ? 145 : 355, y: 128 + nudge, s: 0.75 } : { x: right ? 145 : 355, y: 182 + nudge, s: 0.6 };
}
/* new text starts at a size that fits the panel it lands on (a guess from the letter count; it can be resized) */
function fitScale(view, text) {
  const longest = Math.max(1, ...text.split('\n').map((l) => l.length));
  return clamp(round((view === 'panels' ? 80 : 150) / (longest * TEXT_SIZE * 0.66), 2), 0.25, 1);
}
/* the size text is given when it is first put on a panel; typed text keeps being fitted to this until it is resized by hand */
const autoTextScale = (view, text) => Math.min(defaultPlacement(view, 'text').s, fitScale(view, text));
function addLogoItem(view, assetId) {
  const id = uid();
  mutate((s) => {
    const p = defaultPlacement(view, 'logo');
    s.items.push({ id, type: 'logo', view, asset: assetId, x: p.x, y: p.y, s: p.s, r: 0 });
  }, 'art');
  selectedId = id;
  emit('selection');
  return id;
}
function addTextItem(view, text, font, fill, stroke) {
  const id = uid();
  mutate((s) => {
    const p = defaultPlacement(view, 'text');
    s.items.push({ id, type: 'text', view, text, font, fill, stroke: stroke || null, x: p.x, y: p.y, s: autoTextScale(view, text), r: 0 });
  }, 'art', `text:${id}`); //  the same key the typing that follows uses, so a burst of typing is one step to undo
  selectedId = id;
  emit('selection');
  return id;
}
function removeItem(id) {
  mutate((s) => { s.items = s.items.filter((i) => i.id !== id); }, 'art');
  if (selectedId === id) { selectedId = null; emit('selection'); }
}
function updateItem(id, patch, what = 'art', key = null) {
  mutate((s) => {
    const it = s.items.find((i) => i.id === id);
    if (it) Object.assign(it, patch);
  }, what, key || `item:${id}`);
}
function moveItemOrder(id, dir) {
  mutate((s) => {
    const i = s.items.findIndex((x) => x.id === id);
    const j = i + dir;
    if (i < 0 || j < 0 || j >= s.items.length) return;
    const [it] = s.items.splice(i, 1);
    s.items.splice(j, 0, it);
  }, 'art');
}

/* ---------- derived helpers ---------- */
function renderSlots() {
  const out = {};
  SLOT_KEYS.forEach((k) => {
    const s = state.slots[k];
    out[k] = { mode: s.mode, a: s.a.h, b: s.b.h, dir: s.dir, pat: s.pat, size: s.size, seed: s.seed };
  });
  return out;
}

/* ---------- local draft ---------- */
let persistTimer = null;
function persistSoon() {
  clearTimeout(persistTimer);
  persistTimer = setTimeout(persistNow, 350);
}
function persistNow() {
  try {
    const a = {};
    assets.forEach((v, k) => {
      a[k] = { name: v.name, ext: v.ext, ar: v.ar, previewable: v.previewable, url: v.url || '', src: v.src && v.src.length < 700000 ? v.src : '' };
    });
    localStorage.setItem(STORE_KEY, JSON.stringify({ state, assets: a }));
  } catch (e) { /* private mode or quota: the draft simply isn't saved */ }
}
function restoreDraft() {
  try {
    const raw = localStorage.getItem(STORE_KEY);
    if (!raw) return false;
    const d = JSON.parse(raw);
    if (!d || !d.state || d.state.v !== 1) return false;
    state = sanitiseState(d.state);
    Object.keys(d.assets || {}).forEach((id) => {
      const a = d.assets[id];
      assets.set(id, { id, name: a.name, ext: a.ext, ar: a.ar || 1, previewable: !!a.previewable && !!(a.src || a.url), src: a.src || a.url || '', url: a.url || '', status: a.url ? 'uploaded' : 'local' });
    });
    return true;
  } catch (e) { return false; }
}
function clearDraft() {
  try { localStorage.removeItem(STORE_KEY); } catch (e) { /* ignore */ }
}
function resetAll() {
  mutate((s) => {
    const d = defaultState();
    Object.keys(s).forEach((k) => delete s[k]);
    Object.assign(s, d);
  }, 'all');
  selectedId = null;
  clearDraft();
  emit('all');
}

/* ---------- validation ---------- */
const HEX = /^#[0-9a-fA-F]{6}$/;
function sanitiseColour(c, fallback) {
  if (!c || typeof c.h !== 'string' || !HEX.test(c.h)) return fallback;
  return { h: c.h.toUpperCase(), n: typeof c.n === 'string' ? c.n.slice(0, 40) : '' };
}
function sanitiseState(s) {
  const d = defaultState();
  const out = defaultState();
  SLOT_KEYS.forEach((k) => {
    /* designs saved before the logos had a colour of their own had them follow the arm pit */
    const src = (s.slots && (s.slots[k] || (k === 'logos' && s.slots.acc1))) || {};
    out.slots[k] = {
      mode: !isFlatOnly(k) && (src.mode === 'grad' || src.mode === 'pat') ? src.mode : 'flat',
      a: sanitiseColour(src.a, d.slots[k].a),
      b: sanitiseColour(src.b, d.slots[k].b),
      dir: DIRS.some((x) => x.id === src.dir) ? src.dir : 'v',
      pat: PATTERN_IDS.includes(src.pat) ? src.pat : 'marble',
      size: PAT_SIZES.some((z) => z.id === +src.size) ? +src.size : 2,
      seed: Number.isInteger(+src.seed) && +src.seed >= 1 && +src.seed <= 9999 ? +src.seed : 1,
    };
  });
  out.items = (Array.isArray(s.items) ? s.items : []).slice(0, 15).map((it) => {
    const base = {
      id: typeof it.id === 'string' && /^[a-z0-9]{3,12}$/.test(it.id) ? it.id : uid(),
      view: VIEW_LABEL[it.view] ? it.view : 'front',
      x: clamp(+it.x || 250, -50, 550),
      y: clamp(+it.y || 300, -50, 730),
      s: clamp(+it.s || 1, 0.1, 8),
      r: clamp(+it.r || 0, -360, 360),
    };
    if (it.type === 'text') {
      return {
        ...base, type: 'text',
        text: String(it.text || '').slice(0, 60),
        font: FONT_BY_ID.has(it.font) ? it.font : FONTS[0].id,
        fill: sanitiseColour(it.fill, C('White')),
        stroke: it.stroke ? sanitiseColour(it.stroke, null) : null,
      };
    }
    return { ...base, type: 'logo', asset: String(it.asset || '') };
  }).filter((it) => it.type === 'text' ? it.text : it.asset);
  out.notes = String(s.notes || '').slice(0, 1000);
  out.deadline = /^\d{4}-\d{2}-\d{2}$/.test(s.deadline || '') ? s.deadline : '';
  out.flag = typeof s.flag === 'string' ? s.flag.slice(0, 30) : '';
  return out;
}

/* ---------- compact, shareable encoding of the design ---------- */
const b64e = (str) => btoa(unescape(encodeURIComponent(str))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
const b64d = (s) => decodeURIComponent(escape(atob(s.replace(/-/g, '+').replace(/_/g, '/'))));

function encodeDesign() {
  const c = (x) => [x.h.slice(1), x.n || ''];
  const o = {
    v: 3,
    c: SLOT_KEYS.map((k) => { const s = state.slots[k]; return [{ flat: 0, grad: 1, pat: 2 }[s.mode], ...c(s.a), ...c(s.b), s.dir, s.pat, s.size, s.seed]; }),
    i: state.items.map((it) => {
      const common = [it.view, round(it.x), round(it.y), round(it.s, 2), round(it.r)];
      if (it.type === 'text') return ['T', ...common, it.text, it.font, ...c(it.fill), it.stroke ? c(it.stroke) : 0];
      const a = assets.get(it.asset) || {};
      return ['L', ...common, a.name || 'logo', a.url || '', round(a.ar || 1, 3)];
    }),
  };
  return b64e(JSON.stringify(o));
}
function decodeDesign(code) {
  try {
    const o = JSON.parse(b64d(code));
    if (!o || (o.v !== 1 && o.v !== 2 && o.v !== 3)) return null;
    const col = (h, n) => ({ h: `#${h}`, n: n || '' });
    const s = defaultState();
    /* links made before the sleeves had their own colour carry four colours: panels, arm pit, side panels, legs */
    const order = o.v === 1 ? ['base', 'acc1', 'acc2', 'legs'] : SLOT_KEYS;
    order.forEach((k, idx) => {
      const r = (o.c || [])[idx] || [];
      s.slots[k] = { mode: r[0] === 2 ? 'pat' : r[0] ? 'grad' : 'flat', a: col(r[1] || '888888', r[2]), b: col(r[3] || '888888', r[4]), dir: r[5] || 'v', pat: r[6], size: r[7], seed: r[8] };
    });
    if (o.v === 1) s.slots.acc3 = { ...s.slots.base };
    if (!(o.c || [])[5]) s.slots.logos = { ...s.slots.acc1, mode: 'flat' }; //  links made before the logos had a colour: they followed the arm pit
    const pending = [];
    s.items = (o.i || []).map((r) => {
      const base = { id: uid(), view: r[1], x: r[2], y: r[3], s: r[4], r: r[5] };
      if (r[0] === 'T') {
        return { ...base, type: 'text', text: r[6], font: r[7], fill: col(r[8] || 'FFFFFF', r[9]), stroke: r[10] ? col(r[10][0], r[10][1]) : null };
      }
      const aid = uid();
      pending.push({ id: aid, name: String(r[6] || 'logo').slice(0, 80), url: /^https:\/\//.test(r[7] || '') ? r[7] : '', ar: +r[8] || 1 });
      return { ...base, type: 'logo', asset: aid };
    });
    const clean = sanitiseState(s);
    clean.items = clean.items.filter((it) => it.type === 'text' || pending.some((p) => p.id === it.asset));
    pending.forEach((p) => {
      const ext = (p.name.split('.').pop() || '').toLowerCase();
      assets.set(p.id, { id: p.id, name: p.name, ext, ar: p.ar, src: p.url, url: p.url, previewable: !!p.url && PREVIEWABLE.test(ext || 'png'), status: p.url ? 'uploaded' : 'missing' });
    });
    return clean;
  } catch (e) { return null; }
}
function designLink() {
  const base = (CONFIG && CONFIG.pageUrl) || location.href.split('?')[0].split('#')[0];
  return `${base}?d=${encodeDesign()}`;
}

/* ==========================================================================
   06 · STAGE
   The live SVG preview: three views, artwork items you can drag / resize /
   rotate, selection handles, snapping and keyboard nudging.
   ========================================================================== */

let stageEl = null;
let svg = null;
const gGarment = {};
const gArt = {};
let gUi = null;
const textBox = new Map(); // id -> { w, h } measured text box in local units
let drag = null;
let guideX = false;

const esc = (s) => String(s).replace(/[&<>\"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '\"': '&quot;', "'": '&#39;' }[c]));
const svgNS = 'http://www.w3.org/2000/svg';

/* ---------- markup for one artwork item (shared with the proof export) ---------- */
function placeholderMarkup(a, w, h) {
  const label = a.status === 'missing' ? 'LOGO' : (a.ext || 'file').toUpperCase();
  const sub = a.status === 'missing' ? 'file sent separately' : a.name.length > 18 ? `${a.name.slice(0, 16)}…` : a.name;
  return (
    `<rect x="${-w / 2}" y="${-h / 2}" width="${w}" height="${h}" rx="6" fill="rgba(255,255,255,.88)" stroke="#565553" stroke-width="1.4" stroke-dasharray="5 4"/>` +
    `<text x="0" y="-2" text-anchor="middle" font-family="Archivo,Arial,sans-serif" font-weight="800" font-size="${Math.min(22, h * 0.36)}" fill="#141413">${esc(label)}</text>` +
    `<text x="0" y="${Math.min(16, h * 0.3)}" text-anchor="middle" font-family="Archivo,Arial,sans-serif" font-size="${Math.min(9.5, h * 0.17)}" fill="#565553">${esc(sub)}</text>`
  );
}
function itemBox(it) {
  if (it.type === 'logo') {
    const a = assets.get(it.asset);
    const ar = a && a.ar ? a.ar : 1.4;
    return { w: LOGO_W, h: LOGO_W / ar };
  }
  return textBox.get(it.id) || { w: Math.max(40, it.text.length * TEXT_SIZE * 0.55), h: TEXT_SIZE * 1.1 };
}
function textInner(it) {
  const f = FONT_BY_ID.get(it.font) || FONTS[0];
  const lines = it.text.split('\n');
  const tspans = lines
    .map((ln, i) => `<tspan x="0" dy="${i === 0 ? fmt(-(lines.length - 1) * 0.55 + 0.35) : 1.1}em">${esc(ln) || ' '}</tspan>`)
    .join('');
  const stroke = it.stroke ? ` stroke="${it.stroke.h}" stroke-width="5" stroke-linejoin="round" paint-order="stroke"` : '';
  return `<text text-anchor="middle" font-family="${esc(f.css)}" font-size="${TEXT_SIZE}"${f.weight ? ` font-weight="${f.weight}"` : ''} fill="${it.fill.h}"${stroke}>${tspans}</text>`;
}
function itemMarkup(it) {
  const tr = `translate(${fmt(it.x)} ${fmt(it.y)}) rotate(${fmt(it.r)}) scale(${fmt(it.s)})`;
  let inner;
  if (it.type === 'logo') {
    const a = assets.get(it.asset) || { name: 'logo', ext: '', ar: 1.4, status: 'missing' };
    const { w, h } = itemBox(it);
    inner = a.previewable && a.src
      ? `<image href="${esc(a.src)}" x="${-w / 2}" y="${-h / 2}" width="${w}" height="${h}" preserveAspectRatio="xMidYMid meet"/><rect x="${-w / 2}" y="${-h / 2}" width="${w}" height="${h}" fill="transparent"/>`
      : placeholderMarkup(a, w, h);
  } else {
    inner = textInner(it);
  }
  return `<g class="kb-item" data-id="${it.id}" transform="${tr}">${inner}</g>`;
}
const artMarkup = (view) => itemsIn(view).map(itemMarkup).join('');

/* ---------- mount ---------- */
function mountStage(el) {
  stageEl = el;
  el.innerHTML =
    `<svg class="kb-svg" viewBox="0 0 ${VB.w} ${VB.h}" xmlns="${svgNS}" role="img" aria-label="Live preview of your tri suit" preserveAspectRatio="xMidYMid meet">` +
    `<defs><clipPath id="kb-clip-front"><path d="${SUIT_FRONT.sil}"/></clipPath>` +
    `<clipPath id="kb-clip-back"><path d="${SUIT_BACK.sil}"/></clipPath>` +
    `<clipPath id="kb-clip-panels">${panelClipMarkup()}</clipPath>` +
    `<filter id="kb-drop" x="-20%" y="-10%" width="140%" height="130%"><feGaussianBlur in="SourceAlpha" stdDeviation="7"/><feOffset dy="9" result="b"/><feComponentTransfer><feFuncA type="linear" slope=".24"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs>` +
    VIEWS.map((v) =>
      `<g class="kb-view" data-view="${v.id}"><g class="kb-garment" ${v.id === 'panels' ? '' : 'filter="url(#kb-drop)"'}></g>` +
      `<g clip-path="url(#kb-clip-${v.id})"><g class="kb-art"></g></g></g>`
    ).join('') +
    `<g class="kb-ui"></g></svg>`;
  svg = el.querySelector('svg');
  VIEWS.forEach((v) => {
    const g = svg.querySelector(`.kb-view[data-view="${v.id}"]`);
    gGarment[v.id] = g.querySelector('.kb-garment');
    gArt[v.id] = g.querySelector('.kb-art');
  });
  gUi = svg.querySelector('.kb-ui');
  el.tabIndex = 0;

  svg.addEventListener('pointerdown', onPointerDown);
  svg.addEventListener('pointermove', onPointerMove);
  svg.addEventListener('pointerup', onPointerUp);
  svg.addEventListener('pointercancel', onPointerUp);
  svg.addEventListener('touchstart', (e) => { if (e.target.closest('.kb-item,[data-handle]')) e.preventDefault(); }, { passive: false });
  el.addEventListener('keydown', onKey);
  if (window.ResizeObserver) new ResizeObserver(() => renderSelection()).observe(el);
  if (document.fonts && document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', () => { renderArt(activeView); });
}

/* ---------- rendering ---------- */
/* only the view being shown is drawn (patterns are big); the others are drawn when they are switched to */
const garmentStale = new Set();
function drawGarment(id) {
  if (!garmentStale.delete(id)) return;
  const slots = renderSlots();
  const idp = `${id[0]}-`;
  const st = { slots, paints: resolvePaints(slots, idp) };
  gGarment[id].innerHTML = id === 'panels' ? panelsMarkup(st, idp) : suitMarkup(id, st, idp);
}
function renderGarments() {
  VIEWS.forEach((v) => garmentStale.add(v.id));
  drawGarment(activeView);
}
/* colour changes can arrive faster than a pattern can be redrawn (dragging the colour picker), so draw once per frame
   (or after a moment, in a tab that is not being shown) */
let garmentQueued = false;
function renderGarmentsSoon() {
  if (garmentQueued) return;
  garmentQueued = true;
  const run = () => { if (!garmentQueued) return; garmentQueued = false; renderGarments(); };
  requestAnimationFrame(run);
  setTimeout(run, 60);
}
function measureText(view) {
  gArt[view].querySelectorAll('.kb-item').forEach((g) => {
    const t = g.querySelector('text');
    const id = g.dataset.id;
    const it = getItem(id);
    if (t && it && it.type === 'text') {
      try { const b = t.getBBox(); textBox.set(id, { w: Math.max(10, b.width), h: Math.max(10, b.height), cx: b.x + b.width / 2, cy: b.y + b.height / 2 }); } catch (e) { /* not rendered yet */ }
    }
  });
}
function renderArt(view) {
  gArt[view].innerHTML = artMarkup(view);
  measureText(view);
  renderSelection();
}
function renderAllArt() { VIEWS.forEach((v) => { gArt[v.id].innerHTML = artMarkup(v.id); }); measureText(activeView); renderSelection(); }
function renderView() {
  drawGarment(activeView);
  svg.querySelectorAll('.kb-view').forEach((g) => g.setAttribute('display', g.dataset.view === activeView ? 'inline' : 'none'));
  stageEl.dataset.view = activeView;
  measureText(activeView); // text in a view that was hidden can only be measured once it is shown
  renderSelection();
}
function renderStage() {
  renderGarments();
  renderAllArt();
  renderView();
}

/* ---------- selection overlay ---------- */
const pxPerUnit = () => (svg ? svg.getBoundingClientRect().width / VB.w || 1 : 1);
function corners(it) {
  const b = itemBox(it);
  const cx = it.type === 'text' && textBox.get(it.id) ? textBox.get(it.id).cx : 0;
  const cy = it.type === 'text' && textBox.get(it.id) ? textBox.get(it.id).cy : 0;
  const pad = 4;
  const pts = [[-b.w / 2 - pad + cx, -b.h / 2 - pad + cy], [b.w / 2 + pad + cx, -b.h / 2 - pad + cy], [b.w / 2 + pad + cx, b.h / 2 + pad + cy], [-b.w / 2 - pad + cx, b.h / 2 + pad + cy]];
  const a = (it.r * Math.PI) / 180;
  const cos = Math.cos(a);
  const sin = Math.sin(a);
  return pts.map(([x, y]) => [it.x + (x * cos - y * sin) * it.s, it.y + (x * sin + y * cos) * it.s]);
}
function renderSelection() {
  if (!gUi) return;
  const it = selectedId ? getItem(selectedId) : null;
  let o = '';
  if (guideX) o += `<line x1="250" y1="10" x2="250" y2="670" stroke="#E23A4A" stroke-width="1" stroke-dasharray="4 4" vector-effect="non-scaling-stroke" pointer-events="none"/>`;
  if (it && it.view === activeView) {
    const c = corners(it);
    const u = 1 / pxPerUnit();
    const r = 11 * u;
    o += `<polygon points="${c.map((p) => p.map(fmt).join(',')).join(' ')}" fill="none" stroke="#141413" stroke-width="1.5" stroke-dasharray="5 4" vector-effect="non-scaling-stroke" pointer-events="none"/>`;
    const handle = (name, p, icon, cursor) =>
      `<g class="kb-handle" data-handle="${name}" transform="translate(${fmt(p[0])} ${fmt(p[1])}) scale(${fmt(u)})" style="cursor:${cursor}"><circle r="13" fill="#fff" stroke="#141413" stroke-width="1.6"/><path d="${icon}" fill="none" stroke="#141413" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></g>`;
    o += handle('rotate', c[0], 'M-5 -2a6 6 0 1 1 1.5 5M-6 -6.5v4.5h4.5', 'grab');
    o += handle('delete', c[1], 'M-4.5 -4.5l9 9M4.5 -4.5l-9 9', 'pointer');
    o += handle('resize', c[2], 'M-4.5 -4.5l9 9M1 4.5h3.5V1M-1 -4.5h-3.5V-1', 'nwse-resize');
  }
  gUi.innerHTML = o;
}

/* ---------- pointer interaction ---------- */
function svgPoint(e) {
  const p = svg.createSVGPoint();
  p.x = e.clientX;
  p.y = e.clientY;
  const m = svg.getScreenCTM();
  return m ? p.matrixTransform(m.inverse()) : { x: 0, y: 0 };
}
function onPointerDown(e) {
  if (e.button !== undefined && e.button > 0) return;
  stageEl.focus({ preventScroll: true });
  const handleEl = e.target.closest('[data-handle]');
  const itemEl = e.target.closest('.kb-item');
  if (handleEl) {
    const it = getItem(selectedId);
    if (!it) return;
    const kind = handleEl.dataset.handle;
    if (kind === 'delete') { removeItem(it.id); return; }
    const p = svgPoint(e);
    drag = { kind, id: it.id, pid: e.pointerId, p0: p, x0: it.x, y0: it.y, s0: it.s, r0: it.r, d0: Math.hypot(p.x - it.x, p.y - it.y) || 1, a0: Math.atan2(p.y - it.y, p.x - it.x) };
    capture(e.pointerId);
    e.preventDefault();
  } else if (itemEl) {
    const it = getItem(itemEl.dataset.id);
    if (!it) return;
    select(it.id);
    const p = svgPoint(e);
    drag = { kind: 'move', id: it.id, pid: e.pointerId, p0: p, x0: it.x, y0: it.y, moved: false };
    capture(e.pointerId);
    e.preventDefault();
  } else {
    select(null);
  }
}
function patchItemDom(it) {
  const el = gArt[it.view].querySelector(`.kb-item[data-id="${it.id}"]`);
  if (el) el.setAttribute('transform', `translate(${fmt(it.x)} ${fmt(it.y)}) rotate(${fmt(it.r)}) scale(${fmt(it.s)})`);
  renderSelection();
}
function onPointerMove(e) {
  if (!drag || e.pointerId !== drag.pid) return;
  const it = getItem(drag.id);
  if (!it) return;
  const p = svgPoint(e);
  let patch;
  if (drag.kind === 'move') {
    let x = drag.x0 + (p.x - drag.p0.x);
    let y = drag.y0 + (p.y - drag.p0.y);
    guideX = false;
    if (it.view !== 'panels' && Math.abs(x - 250) < 5) { x = 250; guideX = true; }
    patch = { x: clamp(x, 0, VB.w), y: clamp(y, 0, VB.h) };
  } else if (drag.kind === 'resize') {
    const d = Math.hypot(p.x - it.x, p.y - it.y) || 1;
    patch = { s: clamp((drag.s0 * d) / drag.d0, 0.12, 8) };
  } else {
    let deg = drag.r0 + ((Math.atan2(p.y - it.y, p.x - it.x) - drag.a0) * 180) / Math.PI;
    deg = ((deg + 540) % 360) - 180;
    if (e.shiftKey || Math.abs(deg - Math.round(deg / 15) * 15) < 3) deg = Math.round(deg / 15) * 15;
    patch = { r: deg };
  }
  mutate((s) => { Object.assign(s.items.find((i) => i.id === drag.id), patch); }, 'drag', `drag:${drag.id}`);
  patchItemDom(getItem(drag.id));
}
function onPointerUp(e) {
  if (!drag || (e.pointerId !== undefined && e.pointerId !== drag.pid)) return;
  try { svg.releasePointerCapture(drag.pid); } catch (err) { /* already released */ }
  drag = null;
  guideX = false;
  renderSelection();
  persistNow();
  emit('art');
}

/* ---------- keyboard ---------- */
function onKey(e) {
  if (e.target !== stageEl) return;
  const mod = e.ctrlKey || e.metaKey;
  if (mod && (e.key === 'z' || e.key === 'Z')) { e.preventDefault(); if (e.shiftKey) redo(); else undo(); return; }
  if (mod && (e.key === 'y' || e.key === 'Y')) { e.preventDefault(); redo(); return; }
  const it = selectedId ? getItem(selectedId) : null;
  if (!it) return;
  const step = e.shiftKey ? 10 : 1;
  let patch = null;
  switch (e.key) {
    case 'ArrowLeft': patch = { x: it.x - step }; break;
    case 'ArrowRight': patch = { x: it.x + step }; break;
    case 'ArrowUp': patch = { y: it.y - step }; break;
    case 'ArrowDown': patch = { y: it.y + step }; break;
    case '+': case '=': patch = { s: clamp(it.s * 1.06, 0.12, 8) }; break;
    case '-': case '_': patch = { s: clamp(it.s / 1.06, 0.12, 8) }; break;
    case '[': patch = { r: it.r - 5 }; break;
    case ']': patch = { r: it.r + 5 }; break;
    case 'Delete': case 'Backspace': e.preventDefault(); removeItem(it.id); return;
    case 'Escape': select(null); return;
    default: return;
  }
  e.preventDefault();
  updateItem(it.id, patch, 'drag', `key:${it.id}`);
  patchItemDom(getItem(it.id));
}

/* ---------- files dropped straight onto the stage ---------- */
function attachStageDrop(onFiles) {
  ['dragenter', 'dragover'].forEach((t) => stageEl.addEventListener(t, (e) => { if (e.dataTransfer && [...e.dataTransfer.types].includes('Files')) { e.preventDefault(); stageEl.classList.add('is-drop'); } }));
  ['dragleave', 'drop'].forEach((t) => stageEl.addEventListener(t, () => stageEl.classList.remove('is-drop')));
  stageEl.addEventListener('drop', (e) => {
    if (!e.dataTransfer || !e.dataTransfer.files.length) return;
    e.preventDefault();
    onFiles([...e.dataTransfer.files], activeView);
  });
}

function capture(id) {
  try { svg.setPointerCapture(id); } catch (e) { /* synthetic or already-released pointer */ }
}

/* ==========================================================================
   07 · UI SHELL
   Builds the app skeleton, wires events and keeps the panels in sync.
   ========================================================================== */

const ui = {
  root: null,
  openSlot: 'base',
  editStop: { base: 'a', acc1: 'a', acc2: 'a', acc3: 'a', legs: 'a', logos: 'a' },
  textDraft: { view: 'front', font: 'archivo-black', fill: null, outline: false, stroke: null, text: '' },
  textTarget: '', //  the text the "Your text" box is showing: an item's id, or '' for new text
  typing: false, //   true while a key press is being handled, so the box is never rewritten under the customer's fingers
  toastTimer: null,
  fontsLoaded: false,
};

const ICON = {
  svg: (p, extra = '') => `<svg class="kb-i" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" ${extra}>${p}</svg>`,
  undo: null, redo: null, download: null, link: null, reset: null, dice: null, upload: null, trash: null, up: null, down: null, check: null, mail: null, plus: null, minus: null, caret: null, x: null, edit: null,
  wa: '<svg class="kb-i" viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15l-1.3 4.7L7 20.4A10 10 0 1 0 12 2Zm5.3 14.1c-.2.6-1.3 1.2-1.8 1.2-.5.1-1 .1-1.7-.1-.4-.1-.9-.3-1.6-.6-2.8-1.2-4.6-4-4.7-4.2-.1-.2-1.1-1.5-1.1-2.8 0-1.3.7-2 .9-2.2.2-.3.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 2c.1.2.1.3 0 .5l-.4.5-.3.3c-.2.2-.3.4-.1.7.2.3.9 1.4 1.9 2.3 1.3 1.1 2.3 1.5 2.6 1.6.3.1.5.1.7-.1l.9-1c.2-.3.4-.2.7-.1l2 .9c.3.2.5.2.6.4.1.1.1.7-.1 1.3Z"/></svg>',
};
Object.assign(ICON, {
  undo: ICON.svg('<path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/>'),
  redo: ICON.svg('<path d="m15 14 5-5-5-5"/><path d="M20 9H9.5a5.5 5.5 0 0 0 0 11H13"/>'),
  download: ICON.svg('<path d="M12 4v11m-5-4 5 5 5-5M5 20h14"/>'),
  link: ICON.svg('<path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1"/><path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1"/>'),
  reset: ICON.svg('<path d="M4 4v6h6"/><path d="M5.6 15a8 8 0 1 0 1.3-8.6L4 10"/>'),
  dice: ICON.svg('<rect x="4" y="4" width="16" height="16" rx="3"/><circle cx="9" cy="9" r="1" fill="currentColor"/><circle cx="15" cy="15" r="1" fill="currentColor"/><circle cx="15" cy="9" r="1" fill="currentColor"/><circle cx="9" cy="15" r="1" fill="currentColor"/>'),
  upload: ICON.svg('<path d="M12 16V4m-5 5 5-5 5 5M5 20h14"/>'),
  trash: ICON.svg('<path d="M5 7h14M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/>'),
  up: ICON.svg('<path d="m6 15 6-6 6 6"/>'),
  down: ICON.svg('<path d="m6 9 6 6 6-6"/>'),
  check: ICON.svg('<path d="m5 12.5 4.5 4.5L19 7.5"/>'),
  mail: ICON.svg('<rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/>'),
  plus: ICON.svg('<path d="M12 5v14M5 12h14"/>'),
  minus: ICON.svg('<path d="M5 12h14"/>'),
  caret: ICON.svg('<path d="m6 9 6 6 6-6"/>'),
  x: ICON.svg('<path d="M6 6l12 12M18 6 6 18"/>'),
  edit: ICON.svg('<path d="M4 20h4L19 9l-4-4L4 16v4zM13 7l4 4"/>'),
});

const STEPS = [
  ['kb-s1', 'Colours'], ['kb-s2', 'Logos'], ['kb-s3', 'Text'], ['kb-s4', 'Notes'], ['kb-s5', 'Send'],
];
const $ = (sel, root = ui.root) => root.querySelector(sel);
const $$ = (sel, root = ui.root) => [...root.querySelectorAll(sel)];

function buildShell() {
  const tabs = VIEWS.map((v, i) => `<button type="button" role="tab" class="kb-tab" data-view="${v.id}" id="kb-tab-${v.id}" aria-selected="${i === 0}" tabindex="${i === 0 ? 0 : -1}">${v.id === 'panels' ? '<span class="kb-tab-long">Sleeves + side panels</span><span class="kb-tab-short">Sleeves + sides</span>' : v.label}</button>`).join('');
  const nav = STEPS.map(([id, label], i) => `<a href="#${id}" data-step-link="${id}"><b>0${i + 1}</b> ${label}</a>`).join('');
  const flags = FLAGS.map((f) => `<option value="${esc(f.name)}">${esc(f.name)}</option>`).join('');
  const chartLink = CONFIG.pantoneUrl ? ` <a href="${esc(CONFIG.pantoneUrl)}" target="_blank" rel="noopener">See the Pantone chart</a>.` : '';
  return `
  <div class="kb-left">
    <div class="kb-stage-card">
      <div class="kb-tabs" role="tablist" aria-label="Suit view">${tabs}</div>
      <div class="kb-stage" data-kb-stage aria-label="Suit preview. Drag artwork to move it."></div>
      <p class="kb-hint" data-kb-hint>Drag artwork to move it · corner to resize · top-left to rotate</p>
      <div class="kb-tools">
        <button type="button" class="kb-icon-btn" data-act="undo" aria-label="Undo" title="Undo (Ctrl+Z)">${ICON.undo}</button>
        <button type="button" class="kb-icon-btn" data-act="redo" aria-label="Redo" title="Redo">${ICON.redo}</button>
        <span class="kb-spacer"></span>
        <button type="button" class="kb-link-btn" data-act="proof">${ICON.download}<span>Download picture</span></button>
        <button type="button" class="kb-link-btn" data-act="link">${ICON.link}<span>Copy design link</span></button>
        <button type="button" class="kb-link-btn" data-act="reset">${ICON.reset}<span>Start again</span></button>
        <button type="button" class="kb-icon-btn kb-min-btn" data-act="toggle-stage" aria-expanded="true" aria-label="Hide preview" title="Hide or show the preview">${ICON.caret}</button>
      </div>
    </div>
  </div>
  <div class="kb-right">
    <nav class="kb-steps" aria-label="Design steps">${nav}</nav>

    <section class="kb-sec" id="kb-s1" aria-labelledby="kb-h1">
      <h3 class="kb-h" id="kb-h1"><span class="kb-num">01</span>Design colours</h3>
      <div class="kb-row">
        <button type="button" class="btn btn--ghost" data-act="random">${ICON.dice}<span>Randomise</span></button>
        <label class="kb-select"><span class="kb-sr">Flag colours</span><select data-kb-flag><option value="">Flag colours…</option>${flags}</select></label>
      </div>
      <p class="kb-help">Pick a colour, a gradient or a pattern for each part of the suit, except the legs and the logos, which are each one flat colour. Flag colours set the panels, arm pit and side panels, the sleeves follow the panels and the logos follow the arm pit. Leg colour stays as you set it. Colours on screen are a guide, we print to Pantone (PMS) and I’ll check anything that won’t print accurately before it goes near production.${chartLink}</p>
      <div class="kb-slots" data-kb-slots></div>
    </section>

    <section class="kb-sec" id="kb-s2" aria-labelledby="kb-h2">
      <h3 class="kb-h" id="kb-h2"><span class="kb-num">02</span>Upload logos</h3>
      <p class="kb-help">Vector files (.ai, .eps or .pdf) give the cleanest print. Low-res images pulled off Google come out pixelated. You’ll need to own or have permission to use any club or sponsor logo.</p>
      <div class="kb-areas" data-kb-areas></div>
    </section>

    <section class="kb-sec" id="kb-s3" aria-labelledby="kb-h3">
      <h3 class="kb-h" id="kb-h3"><span class="kb-num">03</span>Add text <em>optional</em></h3>
      <div class="kb-text" data-kb-text></div>
    </section>

    <section class="kb-sec" id="kb-s4" aria-labelledby="kb-h4">
      <h3 class="kb-h" id="kb-h4"><span class="kb-num">04</span>Notes <em>optional</em></h3>
      <div class="kb-callout"><b>A note from Chris</b><p>I redraw every design by hand before it goes anywhere near print, so what you build here is a starting point for ideas, not a locked file. Tell me anything the builder can’t do and I’ll sort it, then send you a proof to approve. The design service is free.</p></div>
      <label class="kb-field"><span class="kb-lab">Anything else I should know?</span>
        <textarea data-kb-notes rows="4" maxlength="1000" placeholder="Exact colour matches, sponsor names, where logos should sit, how many suits you need…"></textarea>
        <span class="kb-count" data-kb-notes-count>0 / 1000</span></label>
      <label class="kb-field kb-field--inline"><span class="kb-lab">Need it by? <small>(race or event date)</small></span>
        <input type="date" data-kb-deadline></label>
      <p class="kb-help" data-kb-timeline></p>
    </section>

    <section class="kb-sec kb-sec--sum" id="kb-s5" aria-labelledby="kb-h5">
      <h3 class="kb-h" id="kb-h5"><span class="kb-num">05</span>Send it to Chris</h3>
      <p class="kb-help">This is for design ideas, so there’s nothing to buy here. Send me your design and I’ll redraw it, send you a proof, and we’ll sort sizes and price together.</p>
      <dl class="kb-sum" data-kb-sum></dl>
      <div class="kb-cta">
        <div class="kb-cta-alt">
          <button type="button" class="btn btn--go" data-act="whatsapp">${ICON.wa}<span>Send on WhatsApp</span></button>
          <button type="button" class="btn btn--ghost" data-act="email">${ICON.mail}<span>Send by email</span></button>
        </div>
        <div class="kb-mail" data-kb-mail hidden>
          <p class="kb-mail-h" role="status">Email app didn’t open? Use one of these instead:</p>
          <div class="kb-mail-btns">
            <button type="button" class="btn btn--ghost" data-act="mail-gmail">Open Gmail</button>
            <button type="button" class="btn btn--ghost" data-act="mail-outlook">Open Outlook</button>
            <button type="button" class="btn btn--ghost" data-act="mail-copy">Copy message</button>
          </div>
          <textarea class="kb-mail-text" data-kb-mail-text rows="7" readonly hidden aria-label="Your message, ready to copy"></textarea>
          <p class="kb-fine">Or copy the message and email it to <b>${esc(CONFIG.email || '')}</b> from any email account.</p>
        </div>
        <p class="kb-status" data-kb-status role="status" aria-live="polite"></p>
        <p class="kb-fine">Nothing is ordered or charged here. I check every design before it goes to print, I’ll send you a proof to approve first, and nothing is made until you’re happy.</p>
      </div>
    </section>
  </div>
  <div class="kb-toast" data-kb-toast role="status" aria-live="polite"></div>`;
}

/* ---------- small helpers ---------- */
function toast(msg, ms = 2600) {
  const el = $('[data-kb-toast]');
  if (!el) return;
  el.textContent = msg;
  el.classList.add('is-on');
  clearTimeout(ui.toastTimer);
  ui.toastTimer = setTimeout(() => el.classList.remove('is-on'), ms);
}
function setStatus(msg, kind = '') {
  const el = $('[data-kb-status]');
  if (!el) return;
  el.textContent = msg;
  el.dataset.kind = kind;
}
/* a locale the browser understands (Shopify may hand us e.g. "en-GB" or just "en") */
function safeLocale() {
  try { return Intl.NumberFormat.supportedLocalesOf([CONFIG.locale || 'en-GB'])[0] || 'en-GB'; } catch (e) { return 'en-GB'; }
}
function loadFonts() {
  if (ui.fontsLoaded) return;
  ui.fontsLoaded = true;
  const l = document.createElement('link');
  l.rel = 'stylesheet';
  l.href = GOOGLE_FONTS_URL;
  document.head.appendChild(l);
}
const colourPaint = (s) => {
  if (s.mode === 'grad') return `linear-gradient(${{ v: '180deg', h: '90deg', d1: '135deg', d2: '45deg' }[s.dir] || '180deg'}, ${s.a.h}, ${s.b.h})`;
  return s.mode === 'pat' ? `linear-gradient(135deg, ${s.a.h} 50%, ${s.b.h} 50%)` : s.a.h;
};
/* how a colour slot reads in its header and in the summary */
const slotName = (s) => {
  if (s.mode === 'grad') return `${colourName(s.a)} → ${colourName(s.b)}`;
  return s.mode === 'pat' ? `${patName(s.pat)}: ${colourName(s.a)} + ${colourName(s.b)}` : colourName(s.a);
};

/* ---------- 01 colours ---------- */
function swatchBtn(c, sel, extra = '') {
  return `<button type="button" class="kb-sw${sel ? ' is-sel' : ''}${isDark(c.h) ? '' : ' is-light'}" role="radio" aria-checked="${sel}" aria-label="${esc(colourName(c))}" title="${esc(colourName(c))}" style="background:${c.h}" data-h="${c.h}" data-n="${esc(c.n)}" ${extra}></button>`;
}
function editedColour(slot) {
  const s = state.slots[slot];
  return s.mode !== 'flat' && ui.editStop[slot] === 'b' ? s.b : s.a; //  gradients and patterns have two colours
}
/* the pattern choices: a picture of each, how big, and another version of the same pattern */
function patternPickerHTML(s) {
  const tiles = PATTERNS.map((p) => `<button type="button" class="kb-design" role="radio" aria-checked="${s.pat === p.id}" data-pat="${p.id}"><svg viewBox="0 0 100 100" aria-hidden="true">${patternThumb(p.id)}</svg><span>${esc(p.name)}</span></button>`).join('');
  const sizes = PAT_SIZES.map((z) => `<button type="button" aria-pressed="${s.size === z.id}" data-psize="${z.id}">${z.label}</button>`).join('');
  return (
    `<div class="kb-designs" role="radiogroup" aria-label="Pattern">${tiles}</div>` +
    `<div class="kb-row"><div class="kb-seg" role="group" aria-label="Pattern size">${sizes}</div><button type="button" class="btn btn--ghost" data-act="pat-shuffle">${ICON.dice}<span>New variation</span></button></div>` +
    `<p class="kb-help" style="margin:0">Patterns are a guide. I’ll set the real pattern, scale and placement when I redraw your design.</p>`
  );
}
function slotBodyHTML(def) {
  const s = state.slots[def.key];
  const cur = editedColour(def.key);
  const names = s.mode === 'pat' ? ['Background', 'Pattern'] : ['Start', 'End'];
  const stopBtns = s.mode !== 'flat'
    ? `<div class="kb-grad"><div class="kb-stops" role="radiogroup" aria-label="Colour to edit">` +
      ['a', 'b'].map((k, i) => `<button type="button" class="kb-stop${ui.editStop[def.key] === k ? ' is-sel' : ''}" role="radio" aria-checked="${ui.editStop[def.key] === k}" data-stop="${k}"><i style="background:${s[k].h}"></i><span>${names[i]}<small>${esc(colourName(s[k]))}</small></span></button>`).join('') +
      `<button type="button" class="kb-icon-btn" data-act="swap-stops" aria-label="Swap the two colours" title="Swap">⇄</button></div>` +
      (s.mode === 'pat'
        ? patternPickerHTML(s)
        : `<div class="kb-dirs" role="radiogroup" aria-label="Gradient direction">` +
          DIRS.map((d) => `<button type="button" class="kb-dir${s.dir === d.id ? ' is-sel' : ''}" role="radio" aria-checked="${s.dir === d.id}" data-dir="${d.id}" aria-label="${d.label}" title="${d.label}">${ICON.svg(`<path d="${d.icon}"/>`)}</button>`).join('') +
          `</div>`) +
      `</div>`
    : '';
  const pal = POPULAR.map((c) => swatchBtn(c, c.h.toUpperCase() === cur.h.toUpperCase())).join('');
  return (
    `<p class="kb-help" style="margin:0">${esc(def.hint)}</p>` +
    (isFlatOnly(def.key) ? '' : `<div class="kb-seg" role="group" aria-label="Fill type"><button type="button" aria-pressed="${s.mode === 'flat'}" data-mode="flat">Flat</button><button type="button" aria-pressed="${s.mode === 'grad'}" data-mode="grad">Gradient</button><button type="button" aria-pressed="${s.mode === 'pat'}" data-mode="pat">Pattern</button></div>`) +
    stopBtns +
    `<div class="kb-pal" role="radiogroup" aria-label="${def.label} colour">${pal}</div>` +
    `<div class="kb-find"><input type="search" data-kb-find placeholder="Find a Pantone colour, e.g. 286 or Reflex" aria-label="Search Pantone colours" autocomplete="off"><div class="kb-found" data-kb-found hidden></div></div>` +
    `<label class="kb-custom"><span>Any other colour</span><input type="color" data-kb-custom value="${cur.h.toLowerCase()}"><small data-kb-custom-note></small></label>`
  );
}
function buildSlots() {
  const host = $('[data-kb-slots]');
  host.innerHTML = SLOT_DEFS.map((def) => {
    const open = ui.openSlot === def.key;
    return (
      `<div class="kb-slot${open ? ' is-open' : ''}" data-slot="${def.key}">` +
      `<button type="button" class="kb-slot-head" aria-expanded="${open}" data-slot-toggle="${def.key}">` +
      `<i class="kb-chip" data-chip></i><span class="kb-slot-txt"><b>${def.label}</b><small data-slot-name></small></span><span class="kb-caret">${ICON.caret}</span></button>` +
      `<div class="kb-slot-body"${open ? '' : ' hidden'}>${open ? slotBodyHTML(def) : ''}</div></div>`
    );
  }).join('');
  refreshSlotHeads();
  refreshCustomNote();
  syncRoving();
}
function refreshSlotHeads() {
  SLOT_DEFS.forEach((def) => {
    const el = $(`.kb-slot[data-slot="${def.key}"]`);
    if (!el) return;
    const s = state.slots[def.key];
    $('[data-chip]', el).style.background = colourPaint(s);
    $('[data-slot-name]', el).textContent = slotName(s);
  });
}
function refreshCustomNote() {
  const el = $(`.kb-slot[data-slot="${ui.openSlot}"]`);
  if (!el) return;
  const note = $('[data-kb-custom-note]', el);
  const cur = editedColour(ui.openSlot);
  if (note) note.textContent = cur.n ? '' : `Nearest ${nearestPms(cur.h).name}`;
}
function refreshOpenSlotSelection() {
  const el = $(`.kb-slot[data-slot="${ui.openSlot}"]`);
  if (!el) return;
  const cur = editedColour(ui.openSlot);
  $$('.kb-sw', el).forEach((b) => { const on = b.dataset.h.toUpperCase() === cur.h.toUpperCase(); b.classList.toggle('is-sel', on); b.setAttribute('aria-checked', String(on)); });
  const inp = $('[data-kb-custom]', el);
  if (inp && document.activeElement !== inp) inp.value = cur.h.toLowerCase();
  refreshCustomNote();
}
function setSlotColour(slot, c, what = 'colours') {
  mutate((s) => {
    const sl = s.slots[slot];
    if (sl.mode !== 'flat' && ui.editStop[slot] === 'b') sl.b = c; else sl.a = c;
    s.flag = '';
  }, what, `colour:${slot}`);
}
function onColourChanged() {
  refreshSlotHeads();
  refreshOpenSlotSelection();
  // gradient stop labels
  const el = $(`.kb-slot[data-slot="${ui.openSlot}"]`);
  if (el && state.slots[ui.openSlot].mode !== 'flat') {
    ['a', 'b'].forEach((k) => {
      const b = $(`.kb-stop[data-stop="${k}"]`, el);
      if (b) { $('i', b).style.background = state.slots[ui.openSlot][k].h; $('small', b).textContent = colourName(state.slots[ui.openSlot][k]); }
    });
  }
  const flagSel = $('[data-kb-flag]');
  if (flagSel) flagSel.value = state.flag || '';
}
function searchPantone(q) {
  const s = q.trim().toLowerCase();
  if (!s) return [];
  const pool = PANTONE.filter((p) => p.name.toLowerCase().includes(s) || p.hex.toLowerCase().includes(s.replace('#', '')));
  return pool.slice(0, 40);
}
function renderFound(el, q) {
  const box = $('[data-kb-found]', el);
  const res = searchPantone(q);
  if (!q.trim()) { box.hidden = true; box.innerHTML = ''; return; }
  box.hidden = false;
  box.innerHTML = res.length
    ? res.map((p) => `<button type="button" class="kb-found-item" data-h="${p.hex}" data-n="${esc(p.name)}"><i style="background:${p.hex}"></i><span>${esc(p.name)}</span></button>`).join('')
    : '<p class="kb-found-none">No match. Pick the closest colour and tell me the exact code in your notes.</p>';
}
function applyFlag(name) {
  const f = FLAGS.find((x) => x.name === name);
  if (!f) return;
  mutate((s) => {
    s.slots.base = { ...s.slots.base, mode: 'flat', a: f.base };
    s.slots.acc1 = { ...s.slots.acc1, mode: 'flat', a: f.acc1 };
    s.slots.acc2 = { ...s.slots.acc2, mode: 'flat', a: f.acc2 };
    s.slots.acc3 = { ...s.slots.acc3, mode: 'flat', a: f.acc3 };
    s.slots.logos = { ...s.slots.logos, mode: 'flat', a: f.logos };
    s.flag = name;
  }, 'all');
}
function randomise() {
  const p = PALETTES[Math.floor(Math.random() * PALETTES.length)];
  mutate((s) => {
    SLOT_KEYS.forEach((k) => { s.slots[k] = { ...s.slots[k], mode: 'flat', a: p[k] }; });
    s.flag = '';
  }, 'all');
}

/* ==========================================================================
   08 · UI PANELS
   Logos, text, notes, summary, and all event wiring.
   ========================================================================== */

const TEXT_SWATCHES = ['White', 'Black', 'Cool Gray 7', 'PMS 281', 'PMS 286', 'PMS 306', 'PMS 348', 'PMS 375', 'PMS 109', 'PMS 1495', 'Red 032', 'PMS 186', 'PMS 219', 'PMS 267', 'PMS 465', 'Cool Gray 1'].map(C);
const OUTLINE_SWATCHES = ['Black', 'White', 'PMS 281', 'PMS 186'].map(C);

/* ---------- 02 logos ---------- */
function statusText(a) {
  switch (a.status) {
    case 'uploaded': return 'Uploaded';
    case 'uploading': return `Uploading ${a.pct || 0}%`;
    case 'error': return 'Upload failed, preview only';
    case 'missing': return 'File sent separately';
    default: return CONFIG.cloudinary ? 'Ready' : 'Preview only. I’ll ask for the original file';
  }
}
function logoRow(it) {
  const a = assets.get(it.asset) || { name: 'logo', ext: '', status: 'missing' };
  const thumb = a.previewable && a.src
    ? `<img class="kb-thumb" src="${esc(a.src)}" alt="">`
    : `<span class="kb-thumb kb-thumb--ext">${esc((a.ext || 'file').toUpperCase())}</span>`;
  return (
    `<li class="kb-item-row${selectedId === it.id ? ' is-sel' : ''}" data-id="${it.id}">` +
    `<button type="button" class="kb-row-main" data-act="select-item" data-id="${it.id}">${thumb}<span class="kb-row-txt"><b>${esc(a.name)}</b><small>${esc(statusText(a))}</small></span></button>` +
    `<span class="kb-row-btns"><button type="button" class="kb-icon-btn" data-act="item-up" data-id="${it.id}" aria-label="Bring forward" title="Bring forward">${ICON.up}</button>` +
    `<button type="button" class="kb-icon-btn" data-act="item-down" data-id="${it.id}" aria-label="Send back" title="Send back">${ICON.down}</button>` +
    `<button type="button" class="kb-icon-btn" data-act="item-del" data-id="${it.id}" aria-label="Remove ${esc(a.name)}" title="Remove">${ICON.trash}</button></span></li>`
  );
}
function renderAreas() {
  const host = $('[data-kb-areas]');
  if (!host) return;
  const accept = ACCEPT_EXT.map((e) => `.${e}`).join(',');
  host.innerHTML = VIEWS.map((v) => {
    const logos = itemsIn(v.id).filter((i) => i.type === 'logo');
    const full = logos.length >= MAX_ART_PER_VIEW;
    return (
      `<div class="kb-area" data-view="${v.id}">` +
      `<div class="kb-area-head"><b>${v.label}</b><span class="kb-count">${logos.length} / ${MAX_ART_PER_VIEW} uploaded</span></div>` +
      `<label class="kb-drop${full ? ' is-full' : ''}" data-drop="${v.id}">` +
      `<input type="file" class="kb-sr" multiple accept="${accept}" data-kb-file="${v.id}"${full ? ' disabled' : ''}>` +
      `${ICON.upload}<span><b>${full ? 'Limit reached' : 'Drop a file here'}</b>${full ? '' : ' or <u>browse</u>'}</span><small>PNG, JPG, SVG, PDF, AI or EPS · up to ${MAX_FILE_MB} MB</small></label>` +
      `${logos.length ? `<ul class="kb-list">${logos.map(logoRow).join('')}</ul>` : `<p class="kb-empty">No ${v.id === 'panels' ? 'sleeve or side panel' : v.label.toLowerCase()} logos yet</p>`}` +
      `</div>`
    );
  }).join('');
}

/* ---------- 03 text ---------- */
function buildTextUI() {
  const host = $('[data-kb-text]');
  host.innerHTML =
    `<div class="kb-tc-banner" data-tc-banner hidden><span>Editing your text</span><button type="button" class="kb-link-btn" data-act="text-done">${ICON.plus}Add another text</button></div>` +
    `<div class="kb-field" data-tc-placewrap><span class="kb-lab">Place on</span><div class="kb-seg" role="group" aria-label="Place text on">${VIEWS.map((v) => `<button type="button" data-tc-view="${v.id}" aria-pressed="false">${v.id === 'panels' ? 'Sleeves + sides' : v.label}</button>`).join('')}</div></div>` +
    `<div class="kb-field"><span class="kb-lab">Your text <small>(it appears on the suit as you type)</small></span><textarea data-tc-text rows="2" maxlength="60" aria-label="Your text" placeholder="Name, club, slogan…"></textarea></div>` +
    `<div class="kb-field"><span class="kb-lab">Font</span><div class="kb-fonts" role="radiogroup" aria-label="Font">${FONTS.map((f) => `<button type="button" class="kb-font" role="radio" aria-checked="false" data-font="${f.id}" style="font-family:${f.css};${f.weight ? `font-weight:${f.weight}` : ''}"><span>Aa</span><small>${esc(f.name)}</small></button>`).join('')}</div></div>` +
    `<div class="kb-field"><span class="kb-lab">Text colour</span><div class="kb-mini" role="radiogroup" aria-label="Text colour" data-tc-fill>${TEXT_SWATCHES.map((c) => swatchBtn(c, false, 'data-tc-fillsw')).join('')}<label class="kb-mini-custom" title="Any other colour"><input type="color" data-tc-fillcustom value="#ffffff" aria-label="Custom text colour"></label></div></div>` +
    `<div class="kb-field kb-field--inline"><label class="kb-check"><input type="checkbox" data-tc-outline><span>Outline</span></label><div class="kb-mini" role="radiogroup" aria-label="Outline colour" data-tc-stroke>${OUTLINE_SWATCHES.map((c) => swatchBtn(c, false, 'data-tc-strokesw')).join('')}</div></div>` +
    `<div class="kb-tl" data-tc-lists></div>`;
  syncTextComposer();
}
function currentTextDraft() {
  const it = selectedId ? getItem(selectedId) : null;
  if (it && it.type === 'text') return { editing: it, view: it.view, font: it.font, fill: it.fill, outline: !!it.stroke, stroke: it.stroke || ui.textDraft.stroke, text: it.text };
  return { editing: null, ...ui.textDraft };
}
function syncTextComposer() {
  const host = $('[data-kb-text]');
  if (!host || !$('[data-tc-banner]', host)) return;
  const d = currentTextDraft();
  if (!ui.textDraft.fill) ui.textDraft.fill = C('White');
  if (!ui.textDraft.stroke) ui.textDraft.stroke = C('Black');
  const d2 = currentTextDraft();
  $('[data-tc-banner]', host).hidden = !d2.editing;
  $('[data-tc-placewrap]', host).hidden = !!d2.editing;
  $$('[data-tc-view]', host).forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.tcView === d2.view)));
  $$('.kb-font', host).forEach((b) => b.setAttribute('aria-checked', String(b.dataset.font === d2.font)));
  const fillHex = d2.fill.h.toUpperCase();
  $$('[data-tc-fillsw]', host).forEach((b) => { const on = b.dataset.h.toUpperCase() === fillHex; b.classList.toggle('is-sel', on); b.setAttribute('aria-checked', String(on)); });
  const fc = $('[data-tc-fillcustom]', host); if (fc && document.activeElement !== fc) fc.value = d2.fill.h.toLowerCase();
  const strokeHex = d2.stroke.h.toUpperCase();
  $('[data-tc-outline]', host).checked = d2.outline;
  $$('[data-tc-strokesw]', host).forEach((b) => { const on = d2.outline && b.dataset.h.toUpperCase() === strokeHex; b.classList.toggle('is-sel', on); b.setAttribute('aria-checked', String(on)); b.disabled = !d2.outline; });
  /* the box follows the selection, even while it still has focus (tapping a button on a phone doesn't take focus away),
     but is left alone while the customer is typing in it */
  const ta = $('[data-tc-text]', host);
  const target = d2.editing ? d2.editing.id : '';
  if (ta && !ui.typing && (document.activeElement !== ta || ui.textTarget !== target)) ta.value = d2.text;
  ui.textTarget = target;
  renderTextLists();
}
function renderTextLists() {
  const host = $('[data-tc-lists]');
  if (!host) return;
  const rows = VIEWS.map((v) => {
    const list = itemsIn(v.id).filter((i) => i.type === 'text');
    if (!list.length) return '';
    return (
      `<div class="kb-tl-group"><b>${v.id === 'panels' ? 'Sleeves + side panels' : v.label} text</b><ul class="kb-list">` +
      list.map((it) => {
        const f = FONT_BY_ID.get(it.font) || FONTS[0];
        return (
          `<li class="kb-item-row${selectedId === it.id ? ' is-sel' : ''}" data-id="${it.id}">` +
          `<button type="button" class="kb-row-main" data-act="select-item" data-id="${it.id}"><span class="kb-thumb kb-thumb--txt" style="font-family:${f.css};background:${isDark(it.fill.h) ? '#e9e8e5' : '#2a2a2a'};color:${it.fill.h}">Aa</span><span class="kb-row-txt"><b>${esc(it.text.replace(/\n/g, ' '))}</b><small>${esc(f.name)}</small></span></button>` +
          `<span class="kb-row-btns"><button type="button" class="kb-icon-btn" data-act="item-del" data-id="${it.id}" aria-label="Remove text" title="Remove">${ICON.trash}</button></span></li>`
        );
      }).join('') +
      `</ul></div>`
    );
  }).join('');
  host.innerHTML = rows || '<p class="kb-empty">No text added yet</p>';
}
/* Typing is all it takes: the first letters put new text on the suit, and typing on changes that text as you go.
   Text that was sized to fit keeps being fitted as it grows; text the customer has resized by hand is left alone. */
function typeText(value) {
  ui.typing = true;
  try { typeTextNow(value); } finally { ui.typing = false; }
}
function typeTextNow(value) {
  loadFonts();
  const d = ui.textDraft;
  const text = value.trim();
  const it = selectedId ? getItem(selectedId) : null;
  if (it && it.type === 'text') {
    if (text) {
      if (text === it.text) return; //  only a space at the end so far
      const patch = { text };
      if (Math.abs(it.s - autoTextScale(it.view, it.text)) < 0.005) patch.s = autoTextScale(it.view, text);
      updateItem(it.id, patch, 'art', `text:${it.id}`);
    } else {
      d.text = value; //  every letter deleted: the text comes off the suit, and the next letter typed starts new text
      removeItem(it.id);
    }
    return;
  }
  d.text = value;
  if (!text) return; //  only spaces so far: there is nothing to put on the suit yet
  if (itemsIn(d.view).length >= MAX_ART_PER_VIEW * 2) { toast('That area is full'); return; }
  d.text = ''; //  from here on the text lives on the suit
  setView(d.view); // switch first: changing view clears the selection
  addTextItem(d.view, text, d.font, d.fill, d.outline ? d.stroke : null);
}
/* "Add another text": let go of this one and empty the box, so the next letters typed are new text */
function finishText() {
  ui.textDraft.text = '';
  const ta = $('[data-tc-text]');
  if (ta) { ta.value = ''; ta.focus({ preventScroll: true }); }
  select(null);
  syncTextComposer();
}
function applyTextChange(patch) {
  const it = selectedId ? getItem(selectedId) : null;
  const d = ui.textDraft; //  new text starts out looking like the last text that was set up
  if ('font' in patch) d.font = patch.font;
  if ('fill' in patch) d.fill = patch.fill;
  if ('stroke' in patch && patch.stroke) d.stroke = patch.stroke;
  if ('outline' in patch) d.outline = patch.outline;
  if (it && it.type === 'text') updateItem(it.id, patch, 'art', `text:${it.id}`);
  else syncTextComposer();
}

/* ---------- files ---------- */
function readAsDataURL(file) {
  return new Promise((res, rej) => { const r = new FileReader(); r.onload = () => res(r.result); r.onerror = rej; r.readAsDataURL(file); });
}
function loadImage(src) {
  return new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = src; });
}
async function makePreview(file, ext) {
  const dataUrl = await readAsDataURL(file);
  if (ext === 'svg') {
    let ar = 1.4;
    try {
      const txt = await file.text();
      const vb = txt.match(/viewBox\s*=\s*["']\s*[-\d.]+[\s,]+[-\d.]+[\s,]+([\d.]+)[\s,]+([\d.]+)/i);
      const w = txt.match(/<svg[^>]*\swidth\s*=\s*["']([\d.]+)/i);
      const h = txt.match(/<svg[^>]*\sheight\s*=\s*["']([\d.]+)/i);
      if (vb && +vb[2] > 0) ar = +vb[1] / +vb[2];
      else if (w && h && +h[1] > 0) ar = +w[1] / +h[1];
    } catch (e) { /* keep default */ }
    return { src: dataUrl, ar: clamp(ar, 0.1, 10) };
  }
  const img = await loadImage(dataUrl);
  const max = 1200;
  const k = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
  const cv = document.createElement('canvas');
  cv.width = Math.max(1, Math.round(img.naturalWidth * k));
  cv.height = Math.max(1, Math.round(img.naturalHeight * k));
  cv.getContext('2d').drawImage(img, 0, 0, cv.width, cv.height);
  const isJpeg = /^jpe?g$/i.test(ext);
  return { src: cv.toDataURL(isJpeg ? 'image/jpeg' : 'image/png', 0.9), ar: clamp(img.naturalWidth / img.naturalHeight, 0.1, 10) };
}
async function addFiles(files, view) {
  let added = 0;
  for (const file of files) {
    if (itemsIn(view).filter((i) => i.type === 'logo').length >= MAX_ART_PER_VIEW) { toast(`${VIEW_LABEL[view]} is full (${MAX_ART_PER_VIEW} max)`); break; }
    const ext = (file.name.split('.').pop() || '').toLowerCase();
    if (!ACCEPT_EXT.includes(ext)) { toast(`${file.name}: that file type isn’t supported`); continue; }
    if (file.size > MAX_FILE_MB * 1024 * 1024) { toast(`${file.name} is over ${MAX_FILE_MB} MB`); continue; }
    const id = uid();
    const a = { id, name: file.name.slice(0, 80), ext, file, ar: 1.4, src: '', previewable: false, url: '', status: 'local', pct: 0 };
    if (PREVIEWABLE.test(ext)) {
      try { const p = await makePreview(file, ext); a.src = p.src; a.ar = p.ar; a.previewable = true; } catch (e) { a.previewable = false; }
    }
    assets.set(id, a);
    setView(view); // switch first: changing view clears the selection
    addLogoItem(view, id);
    added++;
    uploadAsset(a);
  }
  if (added) toast(added === 1 ? 'Logo added. Drag it into place' : `${added} logos added`);
}
function uploadAsset(a) {
  const cfg = CONFIG.cloudinary;
  if (!cfg || !a.file) return;
  a.status = 'uploading';
  a.pct = 0;
  const fd = new FormData();
  fd.append('file', a.file);
  fd.append('upload_preset', cfg.preset);
  fd.append('folder', cfg.folder || 'is3-suit-builder');
  const xhr = new XMLHttpRequest();
  xhr.open('POST', `https://api.cloudinary.com/v1_1/${encodeURIComponent(cfg.cloud)}/auto/upload`);
  xhr.upload.onprogress = (e) => { if (e.lengthComputable) { a.pct = Math.round((e.loaded / e.total) * 100); updateAssetStatus(a); } };
  xhr.onload = () => {
    try {
      const res = JSON.parse(xhr.responseText);
      if (xhr.status >= 200 && xhr.status < 300 && res.secure_url) { a.url = res.secure_url; a.status = 'uploaded'; } else { a.status = 'error'; }
    } catch (e) { a.status = 'error'; }
    updateAssetStatus(a);
    persistNow();
  };
  xhr.onerror = () => { a.status = 'error'; updateAssetStatus(a); };
  xhr.send(fd);
}
function updateAssetStatus(a) {
  $$(`.kb-item-row`).forEach((row) => {
    const it = getItem(row.dataset.id);
    if (it && it.asset === a.id) { const s = $('small', row); if (s) s.textContent = statusText(a); }
  });
}

/* ---------- 04 notes / timeline ---------- */
const fmtDate = (d) => new Intl.DateTimeFormat(safeLocale(), { day: 'numeric', month: 'short', year: 'numeric' }).format(d);
function timelineText() {
  const min = CONFIG.prodWeeksMin || 4;
  const max = CONFIG.prodWeeksMax || 5;
  let t = `If it goes ahead, it’s made to order: ${min}–${max} weeks from design sign-off, then tracked delivery.`;
  if (state.deadline) {
    const d = new Date(`${state.deadline}T12:00:00`);
    const latest = new Date(d.getTime() - (max * 7 + 5) * 86400000);
    const now = new Date();
    if (latest < now) t += ` For ${fmtDate(d)} that’s tight. Message me and I’ll tell you what’s possible.`;
    else t += ` To have it by ${fmtDate(d)}, the design needs signing off by about ${fmtDate(latest)}.`;
  } else {
    t += ' Tight deadline? Tell me and I’ll say what’s possible.';
  }
  return t;
}
function syncMeta() {
  const n = $('[data-kb-notes]');
  if (n && document.activeElement !== n) n.value = state.notes;
  $('[data-kb-notes-count]').textContent = `${state.notes.length} / 1000`;
  const d = $('[data-kb-deadline]');
  if (d && document.activeElement !== d) d.value = state.deadline;
  $('[data-kb-timeline]').textContent = timelineText();
}

/* ---------- 05 summary ---------- */
function artSummary() {
  const logos = state.items.filter((i) => i.type === 'logo');
  const texts = state.items.filter((i) => i.type === 'text');
  const parts = [];
  if (logos.length) parts.push(`${logos.length} ${logos.length === 1 ? 'logo' : 'logos'}`);
  if (texts.length) parts.push(`${texts.length} text`);
  return parts.join(' · ') || 'None';
}
function renderSummary() {
  const chip = (s) => `<i class="kb-chip kb-chip--sm" style="background:${colourPaint(s)}"></i>`;
  const rows = [
    ...SLOT_DEFS.map((d) => [d.label, `${chip(state.slots[d.key])}${esc(slotName(state.slots[d.key]))}`]),
    ['Artwork', esc(artSummary())],
  ];
  $('[data-kb-sum]').innerHTML = rows.map(([k, v]) => `<div><dt>${k}</dt><dd>${v}</dd></div>`).join('');
}

/* ---------- tabs ---------- */
function syncTabs() {
  $$('.kb-tab').forEach((t) => { const on = t.dataset.view === activeView; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; });
  const hint = $('[data-kb-hint]');
  if (hint) hint.textContent = activeView === 'panels' ? 'The sleeves and side panels as they’re cut, laid flat. Artwork placed here wraps the finished piece.' : 'Drag artwork to move it · corner to resize · top-left to rotate';
}
function syncRows() {
  $$('.kb-item-row').forEach((r) => r.classList.toggle('is-sel', r.dataset.id === selectedId));
  syncTextComposer();
}
function syncHistoryButtons() {
  const u = $('[data-act="undo"]'); const r = $('[data-act="redo"]');
  if (u) u.disabled = !canUndo();
  if (r) r.disabled = !canRedo();
}

/* ---------- keyboard: one tab stop per radio group, arrows move within it ---------- */
function syncRoving() {
  if (!ui.root) return;
  $$('[role="radiogroup"]').forEach((g) => {
    const radios = [...g.querySelectorAll('[role="radio"]')].filter((r) => !r.disabled);
    if (!radios.length) return;
    const sel = radios.find((r) => r.getAttribute('aria-checked') === 'true') || radios[0];
    radios.forEach((r) => { r.tabIndex = r === sel ? 0 : -1; });
  });
}
function onRadioArrows(e) {
  const grp = e.target.closest('[role="radiogroup"]');
  if (!grp || !e.target.matches('[role="radio"]')) return false;
  const keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'];
  if (!keys.includes(e.key)) return false;
  e.preventDefault();
  const radios = [...grp.querySelectorAll('[role="radio"]')].filter((r) => !r.disabled);
  let i = radios.indexOf(e.target);
  if (e.key === 'Home') i = 0;
  else if (e.key === 'End') i = radios.length - 1;
  else i = (i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1) + radios.length) % radios.length;
  radios[i].focus();
  radios[i].click();
  return true;
}

/* ---------- full / partial renders ---------- */
function fullRender() {
  buildSlots();
  renderAreas();
  buildTextUI();
  renderSummary();
  syncMeta();
  renderStage();
  syncTabs();
  syncHistoryButtons();
  const flagSel = $('[data-kb-flag]');
  if (flagSel) flagSel.value = state.flag || '';
  if (state.items.some((i) => i.type === 'text')) loadFonts();
  syncRoving();
}
function sync(what) {
  syncHistoryButtons();
  switch (what) {
    case 'drag': return;
    case 'selection': renderSelection(); syncRows(); break;
    case 'view': renderView(); syncTabs(); ui.textDraft.view = activeView; syncTextComposer(); break; //  new text goes on the side being looked at
    case 'colours': renderGarmentsSoon(); onColourChanged(); renderSummary(); break;
    case 'art': renderAllArt(); renderAreas(); syncTextComposer(); renderSummary(); break;
    case 'assets': renderAllArt(); renderAreas(); break;
    case 'meta': syncMeta(); return;
    default: fullRender();
  }
  syncRoving();
}

/* ---------- events ---------- */
function onClick(e) {
  const t = e.target;
  const act = t.closest('[data-act]');
  if (act) {
    const id = act.dataset.id;
    switch (act.dataset.act) {
      case 'undo': undo(); return;
      case 'redo': redo(); return;
      case 'random': randomise(); return;
      case 'reset': if (confirm('Start again? This clears your design.')) resetAll(); return;
      case 'proof': downloadProof(); return;
      case 'link': copyDesignLink(); return;
      case 'whatsapp': sendWhatsApp(); return;
      case 'email': sendEmail(); return;
      case 'mail-gmail': openWebmail('gmail'); return;
      case 'mail-outlook': openWebmail('outlook'); return;
      case 'mail-copy': copyEnquiry(); return;
      case 'toggle-stage': {
        const card = $('.kb-stage-card');
        const min = card.classList.toggle('is-min');
        act.setAttribute('aria-expanded', String(!min));
        act.setAttribute('aria-label', min ? 'Show preview' : 'Hide preview');
        return;
      }
      case 'swap-stops': mutate((s) => { const sl = s.slots[ui.openSlot]; [sl.a, sl.b] = [sl.b, sl.a]; }, 'colours'); return;
      case 'pat-shuffle': mutate((s) => { s.slots[ui.openSlot].seed = 1 + Math.floor(Math.random() * 9999); }, 'colours'); return;
      case 'select-item': { const it = getItem(id); if (it) { if (it.view !== activeView) setView(it.view); select(it.id); stageEl.focus({ preventScroll: true }); } return; }
      case 'item-up': moveItemOrder(id, 1); return;
      case 'item-down': moveItemOrder(id, -1); return;
      case 'item-del': removeItem(id); return;
      case 'text-done': finishText(); return;
      default: break;
    }
  }
  const tab = t.closest('.kb-tab');
  if (tab) { setView(tab.dataset.view); return; }
  const tog = t.closest('[data-slot-toggle]');
  if (tog) { ui.openSlot = ui.openSlot === tog.dataset.slotToggle ? '' : tog.dataset.slotToggle; buildSlots(); return; }
  const mode = t.closest('[data-mode]');
  if (mode) { mutate((s) => { s.slots[ui.openSlot].mode = mode.dataset.mode; }, 'colours'); buildSlots(); return; }
  const pat = t.closest('[data-pat]');
  if (pat) { mutate((s) => { s.slots[ui.openSlot].pat = pat.dataset.pat; }, 'colours'); buildSlots(); return; }
  const psize = t.closest('[data-psize]');
  if (psize) { mutate((s) => { s.slots[ui.openSlot].size = +psize.dataset.psize; }, 'colours'); buildSlots(); return; }
  const stop = t.closest('[data-stop]');
  if (stop) {
    ui.editStop[ui.openSlot] = stop.dataset.stop;
    $$('.kb-stop').forEach((b) => { const on = b.dataset.stop === stop.dataset.stop; b.classList.toggle('is-sel', on); b.setAttribute('aria-checked', String(on)); });
    refreshOpenSlotSelection();
    syncRoving();
    return;
  }
  const dir = t.closest('[data-dir]');
  if (dir) { mutate((s) => { s.slots[ui.openSlot].dir = dir.dataset.dir; }, 'colours'); $$('.kb-dir').forEach((b) => { const on = b.dataset.dir === dir.dataset.dir; b.classList.toggle('is-sel', on); b.setAttribute('aria-checked', String(on)); }); return; }
  const sw = t.closest('.kb-sw');
  if (sw && !sw.hasAttribute('data-tc-fillsw') && !sw.hasAttribute('data-tc-strokesw')) { setSlotColour(ui.openSlot, { h: sw.dataset.h.toUpperCase(), n: sw.dataset.n }); return; }
  if (sw && sw.hasAttribute('data-tc-fillsw')) { applyTextChange({ fill: { h: sw.dataset.h.toUpperCase(), n: sw.dataset.n } }); return; }
  if (sw && sw.hasAttribute('data-tc-strokesw')) { applyTextChange({ stroke: { h: sw.dataset.h.toUpperCase(), n: sw.dataset.n }, outline: true }); return; }
  const found = t.closest('.kb-found-item');
  if (found) { setSlotColour(ui.openSlot, { h: found.dataset.h.toUpperCase(), n: found.dataset.n }); const el = $(`.kb-slot[data-slot="${ui.openSlot}"]`); const inp = $('[data-kb-find]', el); inp.value = ''; renderFound(el, ''); return; }
  const tv = t.closest('[data-tc-view]');
  if (tv) { ui.textDraft.view = tv.dataset.tcView; setView(ui.textDraft.view); syncTextComposer(); return; } //  the suit turns to the side the text will go on
  const fb = t.closest('.kb-font');
  if (fb) { loadFonts(); applyTextChange({ font: fb.dataset.font }); return; }
  const link = t.closest('[data-step-link]');
  if (link) { e.preventDefault(); const target = document.getElementById(link.dataset.stepLink); if (target) { const off = stickyOffset() + (window.innerWidth < 900 ? stageBarHeight() : 0) + 56; window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - off, behavior: 'smooth' }); } }
}
function onInput(e) {
  const t = e.target;
  if (t.matches('[data-kb-notes]')) { mutate((s) => { s.notes = t.value.slice(0, 1000); }, 'meta', 'notes'); return; }
  if (t.matches('[data-kb-deadline]')) { mutate((s) => { s.deadline = t.value; }, 'meta', 'deadline'); return; }
  if (t.matches('[data-tc-text]')) { typeText(t.value); return; }
  if (t.matches('[data-kb-find]')) { renderFound(t.closest('.kb-slot'), t.value); return; }
  if (t.matches('[data-kb-custom]')) { const h = t.value.toUpperCase(); setSlotColour(ui.openSlot, { h, n: '' }); return; }
  if (t.matches('[data-tc-fillcustom]')) { applyTextChange({ fill: { h: t.value.toUpperCase(), n: '' } }); }
}
function onChange(e) {
  const t = e.target;
  if (t.matches('[data-kb-flag]')) { if (t.value) applyFlag(t.value); return; }
  if (t.matches('[data-kb-file]')) { const files = [...t.files]; t.value = ''; addFiles(files, t.dataset.kbFile); return; }
  if (t.matches('[data-tc-outline]')) { applyTextChange({ outline: t.checked, stroke: t.checked ? ui.textDraft.stroke : null }); }
}
function onKeyDownRoot(e) {
  if (onRadioArrows(e)) return;
  if (e.target.matches('[data-tc-text]') && e.key === 'Enter' && (e.metaKey || e.ctrlKey)) { e.preventDefault(); finishText(); }
  if (e.target.matches('.kb-tab') && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
    const ids = VIEWS.map((v) => v.id);
    const i = ids.indexOf(activeView);
    const n = ids[(i + (e.key === 'ArrowRight' ? 1 : ids.length - 1)) % ids.length];
    setView(n);
    $(`#kb-tab-${n}`).focus();
  }
}
function attachDropAreas() {
  ui.root.addEventListener('dragover', (e) => { const z = e.target.closest('[data-drop]'); if (z && e.dataTransfer && [...e.dataTransfer.types].includes('Files')) { e.preventDefault(); z.classList.add('is-over'); } });
  ui.root.addEventListener('dragleave', (e) => { const z = e.target.closest('[data-drop]'); if (z) z.classList.remove('is-over'); });
  ui.root.addEventListener('drop', (e) => { const z = e.target.closest('[data-drop]'); if (z) { e.preventDefault(); z.classList.remove('is-over'); addFiles([...e.dataTransfer.files], z.dataset.drop); } });
}

/* ---------- layout helpers ---------- */
function stickyOffset() {
  const h = document.querySelector('.section-header, header.header, #shopify-section-header, .header-wrapper');
  if (!h) return 0;
  const cs = getComputedStyle(h);
  const sticky = cs.position === 'sticky' || cs.position === 'fixed' || (h.parentElement && /sticky|fixed/.test(getComputedStyle(h.parentElement).position));
  return sticky ? Math.round(h.getBoundingClientRect().height) : 0;
}
function stageBarHeight() {
  const c = $('.kb-stage-card');
  return c && window.innerWidth < 900 ? c.getBoundingClientRect().height : 0;
}
function setStickyVar() {
  ui.root.style.setProperty('--kb-top', `${stickyOffset()}px`);
}
function initScrollSpy() {
  if (!('IntersectionObserver' in window)) return;
  const links = {};
  $$('[data-step-link]').forEach((a) => { links[a.dataset.stepLink] = a; });
  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (en.isIntersecting) {
        Object.values(links).forEach((a) => a.removeAttribute('aria-current'));
        const a = links[en.target.id];
        if (a) a.setAttribute('aria-current', 'step');
      }
    });
  }, { rootMargin: '-35% 0px -55% 0px' });
  ['kb-s1', 'kb-s2', 'kb-s3', 'kb-s4', 'kb-s5'].forEach((id) => { const el = document.getElementById(id); if (el) io.observe(el); });
}

/* ==========================================================================
   09 · EXPORT
   Proof sheet (PNG), copy-link, and font embedding for the PNG.
   ========================================================================== */

const toBase64 = (buf) => {
  const bytes = new Uint8Array(buf);
  let bin = '';
  for (let i = 0; i < bytes.length; i += 0x8000) bin += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000));
  return btoa(bin);
};

/* Google Fonts → @font-face rules with the latin subset inlined as base64 */
async function embeddedFontCSS(familyIds) {
  const fonts = [...new Set(familyIds)].map((id) => FONT_BY_ID.get(id)).filter(Boolean);
  if (!fonts.length) return '';
  const url = `https://fonts.googleapis.com/css2?${fonts.map((f) => `family=${f.gf}`).join('&')}&display=swap`;
  const css = await (await fetch(url)).text();
  const parts = css.split('/* ').slice(1);
  let out = '';
  for (const p of parts) {
    const label = p.slice(0, p.indexOf(' */'));
    if (label !== 'latin') continue;
    let rule = p.slice(p.indexOf('@font-face'));
    const m = rule.match(/url\((https:[^)]+)\)/);
    if (!m) continue;
    const buf = await (await fetch(m[1])).arrayBuffer();
    rule = rule.replace(m[0], `url(data:font/woff2;base64,${toBase64(buf)})`);
    out += rule;
  }
  return out;
}

/* remote logo URLs → data URLs so they survive being drawn from an SVG image */
async function inlineRemoteAssets() {
  const map = new Map();
  for (const a of assets.values()) {
    if (a.previewable && a.src && /^https?:/.test(a.src)) {
      try {
        const blob = await (await fetch(a.src, { mode: 'cors' })).blob();
        map.set(a.id, await readAsDataURL(blob));
      } catch (e) { /* leave as is */ }
    }
  }
  return map;
}

function slotChipSVG(s, x, y, w, h, id) {
  if (s.mode === 'pat') {
    return `<clipPath id="${id}c"><rect x="${x}" y="${y}" width="${w}" height="${h}" rx="8"/></clipPath><g clip-path="url(#${id}c)"><rect x="${x}" y="${y}" width="${w}" height="${h}" fill="${s.a.h}"/><path d="M${x + w} ${y}V${y + h}H${x}Z" fill="${s.b.h}"/></g><rect x="${x}" y="${y}" width="${w}" height="${h}" rx="8" fill="none" stroke="rgba(0,0,0,.25)"/>`;
  }
  if (s.mode === 'grad') {
    const c = { v: [0, 0, 0, 1], h: [0, 0, 1, 0], d1: [0, 0, 1, 1], d2: [0, 1, 1, 0] }[s.dir] || [0, 0, 0, 1];
    return `<linearGradient id="${id}" x1="${c[0]}" y1="${c[1]}" x2="${c[2]}" y2="${c[3]}"><stop offset="0" stop-color="${s.a.h}"/><stop offset="1" stop-color="${s.b.h}"/></linearGradient><rect x="${x}" y="${y}" width="${w}" height="${h}" rx="8" fill="url(#${id})" stroke="rgba(0,0,0,.25)"/>`;
  }
  return `<rect x="${x}" y="${y}" width="${w}" height="${h}" rx="8" fill="${s.a.h}" stroke="rgba(0,0,0,.25)"/>`;
}

function proofSVG(fontCss, inlined) {
  const W = 1800;
  const H = 1220; //  the colours sit in two rows of three under the pictures
  const slots = renderSlots();
  const origSrc = new Map();
  inlined.forEach((v, k) => { const a = assets.get(k); origSrc.set(k, a.src); a.src = v; });
  const viewSvg = (v, x, label) => {
    const idp = `x${v.id[0]}-`;
    const st = { slots, paints: resolvePaints(slots, idp) };
    const garment = v.id === 'panels' ? panelsMarkup(st, idp) : suitMarkup(v.id, st, idp);
    const clip = v.id === 'panels'
      ? `<clipPath id="${idp}artclip">${panelClipMarkup()}</clipPath>`
      : `<clipPath id="${idp}artclip"><path d="${SUIT[v.id].sil}"/></clipPath>`;
    return (
      `<svg x="${x}" y="150" width="560" height="762" viewBox="0 0 ${VB.w} ${VB.h}">` +
      `<defs>${clip}</defs><g>${garment}</g><g clip-path="url(#${idp}artclip)">${artMarkup(v.id)}</g></svg>` +
      `<text x="${x + 280}" y="940" text-anchor="middle" font-family="Archivo,Arial,sans-serif" font-weight="700" font-size="20" letter-spacing="2.5" fill="#565553">${label}</text>`
    );
  };
  let chips = '';
  SLOT_DEFS.forEach((d, i) => {
    const s = state.slots[d.key];
    const x = 90 + (i % 3) * 540;
    const y = 988 + Math.floor(i / 3) * 80;
    chips += slotChipSVG(s, x, y, 52, 52, `xc${i}`);
    chips += `<text x="${x + 64}" y="${y + 21}" font-family="Archivo,Arial,sans-serif" font-weight="700" font-size="18" fill="#141413">${d.label}</text>`;
    if (s.mode === 'pat') {
      chips += `<text x="${x + 64}" y="${y + 45}" font-family="Archivo,Arial,sans-serif" font-size="16" fill="#565553">${esc(patName(s.pat))}</text>`;
      chips += `<text x="${x + 64}" y="${y + 65}" font-family="Archivo,Arial,sans-serif" font-size="14" fill="#8C8B87">${esc(`${s.a.n || s.a.h} + ${s.b.n || s.b.h}`)}</text>`;
    } else {
      chips += `<text x="${x + 64}" y="${y + 45}" font-family="Archivo,Arial,sans-serif" font-size="16" fill="#565553">${esc(s.mode === 'grad' ? `${colourName(s.a)} to ${colourName(s.b)}` : colourName(s.a))}</text>`;
    }
  });
  const now = new Intl.DateTimeFormat(safeLocale(), { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date());
  const svgStr =
    `<svg xmlns="http://www.w3.org/2000/svg" width="${W}" height="${H}" viewBox="0 0 ${W} ${H}">` +
    `<defs><style>${fontCss}</style></defs>` +
    `<rect width="${W}" height="${H}" fill="#F3F2F0"/><rect x="40" y="40" width="${W - 80}" height="${H - 80}" rx="18" fill="#FFFFFF" stroke="#DAD8D3"/>` +
    `<text x="90" y="112" font-family="Archivo,Arial,sans-serif" font-weight="800" font-size="40" fill="#141413" letter-spacing="-0.5">iS3 Teamwear</text>` +
    `<text x="90" y="146" font-family="Archivo,Arial,sans-serif" font-size="22" fill="#565553">Tri suit design idea</text>` +
    `<text x="${W - 90}" y="112" text-anchor="end" font-family="Archivo,Arial,sans-serif" font-size="20" fill="#565553">${now}</text>` +
    viewSvg(VIEWS[0], 90, 'FRONT') + viewSvg(VIEWS[1], 620, 'BACK') + viewSvg(VIEWS[2], 1150, 'SLEEVES + SIDE PANELS') +
    `<line x1="90" y1="960" x2="${W - 90}" y2="960" stroke="#DAD8D3"/>` + chips +
    `<text x="90" y="${H - 46}" font-family="Archivo,Arial,sans-serif" font-size="16" fill="#8C8B87">Colours on screen are a guide; we print to Pantone. This is a design idea from the builder, not a final proof. I’ll redraw it and send you a proof to approve before anything is made.</text>` +
    `</svg>`;
  origSrc.forEach((v, k) => { assets.get(k).src = v; });
  return { svgStr, W, H };
}

async function buildProofBlob(scale = 1) {
  const usedFonts = state.items.filter((i) => i.type === 'text').map((i) => i.font);
  let fontCss = '';
  try { fontCss = await embeddedFontCSS(usedFonts); } catch (e) { fontCss = ''; }
  const inlined = await inlineRemoteAssets();
  const { svgStr, W, H } = proofSVG(fontCss, inlined);
  const url = URL.createObjectURL(new Blob([svgStr], { type: 'image/svg+xml;charset=utf-8' }));
  try {
    const img = await loadImage(url);
    const cv = document.createElement('canvas');
    cv.width = W * scale;
    cv.height = H * scale;
    const ctx = cv.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, cv.width, cv.height);
    ctx.drawImage(img, 0, 0, cv.width, cv.height);
    return await new Promise((res) => cv.toBlob(res, 'image/png'));
  } finally {
    URL.revokeObjectURL(url);
  }
}

async function downloadProof() {
  toast('Preparing your picture…', 6000);
  try {
    const blob = await buildProofBlob(1);
    if (!blob) throw new Error('no blob');
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'is3-tri-suit-design.png';
    document.body.appendChild(a);
    a.click();
    setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 1500);
    toast('Picture downloaded');
  } catch (e) {
    toast('Sorry, the picture couldn’t be created in this browser', 4000);
  }
}

/* copy text to the clipboard; if the browser won't allow it, `onFail` gets a go (or a prompt box if there isn't one) */
async function copyText(text, doneMsg, onFail) {
  try {
    await navigator.clipboard.writeText(text);
    toast(doneMsg, 4200);
  } catch (e) {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    let ok = false;
    try { ok = document.execCommand('copy'); } catch (err) { ok = false; }
    ta.remove();
    if (ok) toast(doneMsg, 4200); else if (onFail) onFail(); else window.prompt('Copy this', text);
  }
}
function copyDesignLink() {
  return copyText(designLink(), 'Design link copied', () => window.prompt('Copy your design link', designLink()));
}

/* ==========================================================================
   10 · SEND
   The "send this to Chris" routes (WhatsApp / email). The builder is for
   design ideas: nothing is added to a cart or bought from here.
   ========================================================================== */

const dirLabel = (d) => (DIRS.find((x) => x.id === d) || DIRS[0]).label.toLowerCase();
const slotDesc = (s) => {
  if (s.mode === 'pat') return `${patName(s.pat)} pattern (${patSize(s.size).label.toLowerCase()} scale): ${colourLong(s.a)} background with ${colourLong(s.b)} pattern colour`;
  return s.mode === 'grad' ? `Gradient ${colourLong(s.a)} to ${colourLong(s.b)}, ${dirLabel(s.dir)}` : colourLong(s.a);
};

function artworkLines(view) {
  const out = [];
  itemsIn(view).forEach((it) => {
    if (it.type === 'logo') {
      const a = assets.get(it.asset) || { name: 'logo' };
      out.push(a.url ? `${a.name}: ${a.url}` : `${a.name} (to be emailed)`);
    } else {
      const f = FONT_BY_ID.get(it.font) || FONTS[0];
      out.push(`"${it.text.replace(/\n/g, ' / ')}" (${f.name}, ${colourName(it.fill)}${it.stroke ? `, outline ${colourName(it.stroke)}` : ''})`);
    }
  });
  return out;
}

/* ---------- message Chris ---------- */
function enquiryText(maxNotes = 400, withArtwork = true) {
  const lines = [];
  lines.push('Hi Chris, I’ve put together a tri suit design idea on your site.');
  lines.push('');
  SLOT_DEFS.forEach((d) => lines.push(`${d.label}: ${slotDesc(state.slots[d.key])}`));
  if (withArtwork) VIEWS.forEach((v) => { const a = artworkLines(v.id); if (a.length) lines.push(`${VIEW_LABEL[v.id]} artwork: ${a.join(' | ')}`); });
  if (state.deadline) lines.push(`Need it by: ${fmtDate(new Date(`${state.deadline}T12:00:00`))}`);
  if (state.notes) lines.push(`Notes: ${state.notes.slice(0, maxNotes)}${state.notes.length > maxNotes ? '…' : ''}`);
  lines.push('');
  lines.push(`My design: ${designLink()}`);
  return lines.join('\n');
}
function sendWhatsApp() {
  const num = String(CONFIG.whatsapp || '').replace(/\D/g, '');
  if (!num) { toast('WhatsApp isn’t set up yet'); return; }
  let text = enquiryText();
  if (encodeURIComponent(text).length > 3800) text = enquiryText(120);
  window.open(`https://wa.me/${num}?text=${encodeURIComponent(text)}`, '_blank', 'noopener');
}

/* ---------- email ----------
   A mail link does nothing on a computer with no email app set up, so the button also opens a small box under it
   with other ways to send the same message: Gmail, Outlook, or copy it and paste it into any email. */
const MAIL_SUBJECT = 'Tri suit design idea';
const mailEnc = (t) => encodeURIComponent(t.replace(/\n/g, '\r\n'));
function mailMessage() {
  const to = CONFIG.email || '';
  const link = (t) => `mailto:${to}?subject=${encodeURIComponent(MAIL_SUBJECT)}&body=${mailEnc(t)}`;
  const full = enquiryText(1000);
  let mailto = link(full);
  /* email apps cut off very long links, which would break the design link at the end, so trim the notes first and then the
     artwork lines (the design link already holds the artwork); "Copy message" and the Gmail / Outlook buttons send it all */
  if (mailto.length > 1900) mailto = link(enquiryText(120));
  if (mailto.length > 1900) mailto = link(enquiryText(120, false));
  return { to, full, mailto };
}
const WEBMAIL = {
  gmail: (m) => `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(m.to)}&su=${encodeURIComponent(MAIL_SUBJECT)}&body=${mailEnc(m.full)}`,
  outlook: (m) => `https://outlook.live.com/mail/0/deeplink/compose?to=${encodeURIComponent(m.to)}&subject=${encodeURIComponent(MAIL_SUBJECT)}&body=${mailEnc(m.full)}`,
};
function sendEmail() {
  if (!CONFIG.email) { toast('Email isn’t set up yet'); return; }
  const box = $('[data-kb-mail]');
  if (box) {
    box.hidden = false;
    try { box.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) { /* older browsers just stay put */ }
  }
  const a = document.createElement('a'); //  the same thing a normal "email us" link does
  a.href = mailMessage().mailto;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  a.remove();
}
function openWebmail(kind) {
  if (WEBMAIL[kind]) window.open(WEBMAIL[kind](mailMessage()), '_blank', 'noopener');
}
function copyEnquiry() {
  const m = mailMessage();
  copyText(m.full, `Message copied. Paste it into an email to ${m.to}`, () => {
    const box = $('[data-kb-mail-text]'); //  no clipboard here: show the message so it can be selected by hand
    if (!box) return;
    box.value = m.full;
    box.hidden = false;
    box.focus();
    box.select();
  });
}

/* ==========================================================================
   11 · INIT
   ========================================================================== */

function readConfig(root) {
  const el = root.querySelector('script[data-is3kb-config]') || document.querySelector('script[data-is3kb-config]');
  let cfg = {};
  try { cfg = JSON.parse(el ? el.textContent : '{}'); } catch (e) { cfg = {}; }
  return {
    pageUrl: cfg.pageUrl || '',
    locale: cfg.locale || 'en-GB',
    whatsapp: cfg.whatsapp || '',
    email: cfg.email || '',
    pantoneUrl: cfg.pantoneUrl || '',
    prodWeeksMin: cfg.prodWeeksMin || 4,
    prodWeeksMax: cfg.prodWeeksMax || 5,
    cloudinary: cfg.cloudinaryCloud && cfg.cloudinaryPreset ? { cloud: cfg.cloudinaryCloud, preset: cfg.cloudinaryPreset, folder: cfg.cloudinaryFolder || 'is3-suit-builder' } : null,
    demo: !!cfg.demo,
  };
}

function initBuilder(root) {
  if (!root || root.dataset.kbReady === '1') return;
  root.dataset.kbReady = '1';
  CONFIG = readConfig(root);
  ui.root = root;
  root.innerHTML = buildShell();

  // state: shared link > saved draft > defaults
  let ok = false;
  const d = new URLSearchParams(location.search).get('d');
  if (d) { const s = decodeDesign(d); if (s) { state = s; ok = true; } }
  if (!ok) ok = restoreDraft();
  if (!ok) state = defaultState();
  if (!ui.textDraft.fill) ui.textDraft.fill = C('White');
  if (!ui.textDraft.stroke) ui.textDraft.stroke = C('Black');

  mountStage($('[data-kb-stage]'));
  attachStageDrop(addFiles);
  attachDropAreas();
  root.addEventListener('click', onClick);
  root.addEventListener('input', onInput);
  root.addEventListener('change', onChange);
  root.addEventListener('keydown', onKeyDownRoot);
  on(sync);

  fullRender();
  setStickyVar();
  window.addEventListener('resize', () => { setStickyVar(); renderSelection(); });
  initScrollSpy();
  if (state.items.some((i) => i.type === 'text')) loadFonts();
  root.classList.add('is-ready');
}

function bootAll() {
  document.querySelectorAll('[data-is3kb-app]').forEach(initBuilder);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll); else bootAll();
document.addEventListener('shopify:section:load', bootAll);

window.IS3SuitBuilder = { init: initBuilder };
if (document.querySelector('script[data-is3kb-config]') && /"demo":true/.test(document.querySelector('script[data-is3kb-config]').textContent)) window.IS3SuitBuilder._debug = () => ({ state, assets, selectedId, activeView, undoDepth: undoStack.length, designLink, encodeDesign, decodeDesign, buildProofBlob, enquiryText });


})();
